import React, { useState, useEffect, useRef, useMemo } from 'react';
import DashboardNavbar from './DashboardNavbar';
import axios8001 from '../services/axios8001';
import axios8000 from '../services/8000AxiosInstance';
import axios8400 from '../services/axios8400';
import axios8200 from '../services/axios8200';
import axios8300 from '../services/axios8300';
import './styles.css';
import './DashboardNavbar.css'
import askCoachIcon from "../assets/icons/ask-coach-icon.png";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import ClosingProbabilityTile from "./ClosingProbabilityTile";
import SalesDashboard from './SalesDashboard';


import {
  fetchCustomerId,
  fetchOpportunityId,
  fetchCustomerDetails,
  fetchAccountId,
  fetchAccountLearnings,
  fetchDelayedTasksByRole,
  fetchOpportunityMetrics,
  fetchClosingProbability,
  fetchOpportunityLearnings,
} from "../utils/apiUtils"; // Assuming API utils are properly structured
import { Bar } from 'react-chartjs-2'; // Assuming you're using react-chartjs-2

const renderMetrics = (metrics) => {
  if (!metrics || typeof metrics !== "object") {
    return <p>Metrics: N/A</p>;
  }

  const totalTasks = metrics.total_tasks || 0;
  const deletedTasks = metrics.deleted_tasks_count || 0;

  return (
    <div className="metrics-chart">
      <p>Total Tasks: {totalTasks}</p>
      <p>Deleted Tasks: {deletedTasks}</p>
    </div>
  );
};


const renderSalesStageHealth = (salesStageHealth) => {
  if (!salesStageHealth || !salesStageHealth.stage) {
    return <p>Sales Stage: N/A</p>;
  }

  return (
    <div className="sales-stage-health">
      <p>
        <strong>Sales Stage:</strong> {salesStageHealth.stage}
      </p>
      <div className="progress-bar">
        <label>Meddicc Health</label>
        <progress value={salesStageHealth.meddiccHealth || 0} max="100" />
        <span>{salesStageHealth.meddiccHealth || 0}%</span>
      </div>
      <div className="progress-bar">
        <label>Compliance Score</label>
        <progress value={salesStageHealth.complianceScore || 0} max="100" />
        <span>{salesStageHealth.complianceScore || 0}%</span>
      </div>
    </div>
  );
};

const Dashboard = () => {
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [isSending, setIsSending] = useState(false);
  //const [customerOpportunities, setCustomerOpportunities] = useState({});
  const navigate = useNavigate();
  const [modalType, setModalType] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);

  const [modalContent, setModalContent] = useState(null);
  
  const [isVisible, setIsVisible] = useState(false);

  const toggleTilesVisibility = () => {
    setIsVisible(!isVisible);
  };

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleTiles = () => {
    setIsExpanded((prev) => !prev); // Toggle expanded state
  };


  const [formData, setFormData] = useState({
      customerName: '',
      leadDetails: '',
      opportunityName: '',
      accountPlanName: '',
      contact: '', // For opportunity_contacts
      persona: '', // For opportunity_contacts_persona
      leadSource: '', // For opportunity_source
      persona: '',
      solutionType: '',
      solution: '',
      vendor: '',
  });
  

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };
  
  const [error, setError] = useState('');

  const messagesEndRef = useRef(null);
  const [selectedOpportunityId, setSelectedOpportunityId] = useState(null);
  const [selectedCustomerName, setSelectedCustomerName] = useState(null);
  const [selectedOpportunityName, setSelectedOpportunityName] = useState(null);
  /* Assistant Chat const */
  const [showAskCoachTile, setShowAskCoachTile] = useState(false);
  const [loadingChat, setLoadingChat] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  

  
  const handleButtonClick = (buttonName) => {
    if (buttonName === "ask-coach") {
      setShowAskCoachTile(true);
    } else {
      console.log(`Button ${buttonName} clicked. Implement further logic.`);
      setModalType(modalMapping[buttonName] || null);
    }
  };
  
useEffect(() => {
  console.log("showAskCoachTile state:", showAskCoachTile); // Debug
}, [showAskCoachTile]);

  const location = useLocation();
  const { opportunity_id: urlOpportunityId } = useParams();
  const [opportunityId, setOpportunityId] = useState(urlOpportunityId || "");
  

   

  // Retrieve user ID and API Key
  const userId = sessionStorage.getItem("user_id");
if (!userId) {
  console.error("User ID is missing. Please log in again.");
}

  const apiKey = sessionStorage.getItem("api_key");



 

  // Redirect to login if missing credentials
  useEffect(() => {
    const fetchOpportunities = async () => {
      const data = await fetchCustomerOpportunities(userId, apiKey, setChatMessages);
      if (data && typeof data === 'object') {
        setCustomerOpportunities(data);
      }
    };
    fetchOpportunities();
  }, [userId, apiKey]);
  
  const [customerOpportunities, setCustomerOpportunities] = useState({});

  useEffect(() => {
    const fetchOpportunities = async () => {
      const data = await fetchCustomerOpportunities(userId, apiKey);
      console.log("Fetched opportunities:", data); // Debug log
      setCustomerOpportunities(data || {});
    };
    fetchOpportunities();
  }, [userId, apiKey]);
  
  
  
  
  const initialPrompts = useMemo(
      () => [
          'Do you have a lead or a qualified opportunity?',
          'Need help understanding MEDDICC or improving execution?',
          'Start by creating a Customer Account',
          'Analyse Whys',
      ],
      []
  );

  // Debugging Logs for state monitoring
  
  useEffect(() => {
      if (messages.length === 0) {
          setMessages(initialPrompts.map((prompt) => ({ text: prompt, sender: 'bot' })));
      }
      scrollToBottom();
  }, [messages.length, initialPrompts]);
  
  // useEffect(() => {
  //   console.log('Modal Type:', modalType); // Debugging modal type
  // }, [modalType]);
  
  useEffect(() => {
      const fetchCustomerOpportunities = async () => {
          try {
              const userId = sessionStorage.getItem('user_id');
              if (!userId) {
                  setError('User ID is missing. Redirecting to login...');
                  window.location.href = '/login'; // Redirect to login page
                  return;
              }

              const response = await axios8001.get(`/customer-opportunities?user_id=${userId}`);
              console.log('Customer opportunities fetched:', response.data); // Debugging log

              const normalizedData = Object.entries(response.data.customer_names_with_opportunities || {}).reduce(
                  (acc, [name, opportunities]) => {
                      const trimmedName = name?.trim() || 'Unknown';
                      acc[trimmedName] = acc[trimmedName]
                          ? acc[trimmedName].concat(opportunities)
                          : opportunities || [];
                      return acc;
                  },
                  {}
              );
              setCustomerOpportunities(normalizedData);
          } catch (error) {
              console.error('Error fetching customer opportunities:', error);
              setError('Failed to fetch customer opportunities. Please try again later.');
          }
      };
      fetchCustomerOpportunities();
  }, []);

  const scrollToBottom = () => {
      if (messagesEndRef.current) {
          messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
      }
  };
/* This is for Sales Dashboard code */
  
const [opportunities, setOpportunities] = useState([]);



// const processedData = useMemo(() => {
//   console.log("[Debug] Processing opportunities:", opportunities);

//   if (!opportunities || opportunities.length === 0) {
//     console.log("[Debug] No opportunities found. Returning default values.");
//     return {
//       totalValue: 0,
//       dealsData: [],
//       funnelData: [],
//       forecastData: [],
//     };
//   }

//   const totalValue = opportunities.reduce((sum, opp) => sum + (opp.value || 0), 0);
//   console.log("[Debug] Calculated total value of opportunities:", totalValue);

//   const salesStages = [
//     "Sales Stage 1 Discovery",
//     "Sales Stage 2 Demo",
//     "Sales Stage 3 Technical Deep Dive",
//     "Sales Stage 4 Proof of Value",
//     "Sales Stage 5 Close",
//   ];

//   const dealsData = opportunities.reduce((acc, opp) => {
//     const stage = opp.stage || "Unknown";
//     acc[stage] = (acc[stage] || 0) + 1;
//     return acc;
//   }, {});

//   console.log("[Debug] Generated deals data:", dealsData);

//   const funnelData = salesStages.map((stage) => ({
//     stage,
//     value: opportunities.filter((opp) => opp.stage === stage).length,
//   }));

//   console.log("[Debug] Generated funnel data:", funnelData);

//   const forecastData = opportunities
//     .filter((opp) => opp.commit_date)
//     .reduce((acc, opp) => {
//       const month = new Date(opp.commit_date).toLocaleString("default", { month: "short" });
//       acc[month] = (acc[month] || 0) + (opp.value || 0);
//       return acc;
//     }, {});

//   console.log("[Debug] Generated forecast data:", forecastData);

//   return {
//     totalValue,
//     dealsData: Object.entries(dealsData).map(([stage, value]) => ({ stage, value })),
//     funnelData,
//     forecastData: Object.entries(forecastData).map(([month, revenue]) => ({ month, revenue })),
//   };
// }, [opportunities]);

const processedData = useMemo(() => {
  console.log("[Debug] Processing opportunities:", opportunities);

  if (!opportunities || opportunities.length === 0) {
    console.log("[Debug] No opportunities found. Returning default values.");
    return {
      totalValue: 0,
      dealsData: [],
      funnelData: [],
    };
  }

  const totalValue = opportunities.reduce((sum, opp) => sum + (opp.value || 0), 0);
  console.log("[Debug] Calculated total value of opportunities:", totalValue);

  const salesStages = [
    "Sales Stage 1 Discovery",
    "Sales Stage 2 Demo",
    "Sales Stage 3 Technical Deep Dive",
    "Sales Stage 4 Proof of Value",
    "Sales Stage 5 Close",
  ];

  const dealsData = opportunities.reduce((acc, opp) => {
    const stage = opp.stage || "Unknown";
    acc[stage] = (acc[stage] || 0) + 1;
    return acc;
  }, {});

  console.log("[Debug] Generated deals data:", dealsData);

  const funnelData = salesStages.map((stage) => ({
    stage,
    value: opportunities.filter((opp) => opp.stage === stage).length,
  }));

  console.log("[Debug] Generated funnel data:", funnelData);

  // Forecast Data Calculation
  const forecastData = opportunities
    .filter((opp) => opp.commit_date && opp.value && opp.closing_probability)
    .reduce((acc, opp) => {
      const month = new Date(opp.commit_date).toLocaleString("default", { month: "short" });
      const weightedValue = opp.value * opp.closing_probability * (opp.compliance_score || 1);
      acc[month] = (acc[month] || 0) + weightedValue;
      return acc;
    }, {});

  console.log("[Debug] Generated forecast data:", forecastData);

  return {
    totalValue,
    dealsData: Object.entries(dealsData).map(([stage, value]) => ({ stage, value })),
    funnelData,
    forecastData: Object.entries(forecastData).map(([month, revenue]) => ({ month, revenue })),
  };
}, [opportunities]);

const { totalValue, dealsData, funnelData } = processedData;



console.log("[Debug] Final processed data for Sales Dashboard:", {
  totalValue,
  dealsData,
  funnelData,
 
});


// const fetchSalesDashboardOpportunities = async (userId, apiKey) => {
//   try {
//     const response = await axios8001.get(`/customer-opportunities`, { params: { user_id: userId } });
//     const customers = response.data?.customer_names_with_opportunities || {};

//     const flatOpportunities = [];

//     for (const [customerName, opportunities] of Object.entries(customers)) {
//       try {
//         // Fetch customer_id for the customerName
//         const customerId = await fetchCustomerId(customerName, userId, apiKey);

//         for (const opportunityName of opportunities) {
//           try {
//             // Fetch the opportunity ID using customer_id
//             const opportunityIdResponse = await axios8001.get(`/get_opportunity_id`, {
//               params: {
//                 customer_id: customerId,
//                 opportunity_name: opportunityName,
//                 user_id: userId,
//                 api_key: apiKey,
//               },
//             });

//             const opportunityId = opportunityIdResponse.data.opportunity_id;

//             // Fetch full opportunity details
//             const opportunityDetailsResponse = await axios8001.get(`/get_opportunity_full_details`, {
//               params: { opportunity_id: opportunityId },
//             });

//             const opportunityDetails = opportunityDetailsResponse.data;

//             flatOpportunities.push({
//               opportunityId,
//               customerName,
//               opportunityName,
//               ...opportunityDetails,
//             });
//           } catch (error) {
//             console.warn(`Error fetching details for opportunity: ${opportunityName}`, error);
//           }
//         }
//       } catch (error) {
//         console.warn(`Error fetching customer ID for ${customerName}:`, error);
//       }
//     }

//     return flatOpportunities;
//   } catch (error) {
//     console.error("Error fetching opportunities for Sales Dashboard:", error);
//     return [];
//   }
// };

const fetchSalesDashboardOpportunities = async (userId, apiKey) => {
  try {
    const response = await axios8001.get(`/customer-opportunities`, { params: { user_id: userId } });
    const customers = response.data?.customer_names_with_opportunities || {};

    const flatOpportunities = [];

    for (const [customerName, opportunities] of Object.entries(customers)) {
      try {
        const customerId = await fetchCustomerId(customerName, userId, apiKey);

        for (const opportunityName of opportunities) {
          try {
            const opportunityIdResponse = await axios8001.get(`/get_opportunity_id`, {
              params: {
                customer_id: customerId,
                opportunity_name: opportunityName,
                user_id: userId,
                api_key: apiKey,
              },
            });
            const opportunityId = opportunityIdResponse.data.opportunity_id;

            const opportunityDetailsResponse = await axios8001.get(`/get_opportunity_full_details`, {
              params: { opportunity_id: opportunityId },
            });

            const opportunityDetails = opportunityDetailsResponse.data;

            // Fetch compliance score and closing probability
            const [salesStageHealthResponse, closingProbabilityResponse] = await Promise.all([
              axios8200.get(`/sales_stage_health/${opportunityId}`),
              axios8200.get(`/closing_probability/${opportunityId}`),
            ]);

            const complianceScore = salesStageHealthResponse.data?.compliance_score || 0;
            const closingProbability = closingProbabilityResponse.data?.closing_probability || 0;

            flatOpportunities.push({
              opportunityId,
              customerName,
              opportunityName,
              compliance_score: complianceScore,
              closing_probability: closingProbability,
              ...opportunityDetails,
            });
          } catch (error) {
            console.warn(`Error fetching details for opportunity: ${opportunityName}`, error);
          }
        }
      } catch (error) {
        console.warn(`Error fetching customer ID for ${customerName}:`, error);
      }
    }

    return flatOpportunities;
  } catch (error) {
    console.error("Error fetching opportunities for Sales Dashboard:", error);
    return [];
  }
};


useEffect(() => {
  const fetchOpportunities = async () => {
    const userId = sessionStorage.getItem("user_id");
    const apiKey = sessionStorage.getItem("api_key");

    if (!userId || !apiKey) {
      console.error("User ID or API Key is missing.");
      return;
    }

    const fetchedOpportunities = await fetchSalesDashboardOpportunities(userId, apiKey);
    setOpportunities(fetchedOpportunities);
  };

  fetchOpportunities();
}, []);

const forecastData = opportunities
  .filter((opp) => opp.commit_date && opp.value && opp.closing_probability)
  .reduce((acc, opp) => {
    const month = new Date(opp.commit_date).toLocaleString("default", { month: "short" });
    const weightedValue = opp.value * opp.closing_probability * (opp.compliance_score || 1);
    acc[month] = (acc[month] || 0) + weightedValue;
    return acc;
  }, {});



  // const processOpportunitiesData = (opps) => {
  //     const totalValue = opps.reduce((sum, opp) => sum + (opp.value || 0), 0);

  //     const stages = opps.reduce((acc, opp) => {
  //         acc[opp.stage] = (acc[opp.stage] || 0) + 1;
  //         return acc;
  //     }, {});
  //     const funnelData = Object.entries(stages).map(([stage, value]) => ({
  //         stage,
  //         value,
  //     }));

  //     const forecastData = opps.reduce((acc, opp) => {
  //         const commitDate = new Date(opp.commit_date);
  //         const month = commitDate.toLocaleString("default", { month: "short" });
  //         const existingMonth = acc.find((item) => item.month === month);

  //         if (existingMonth) {
  //             existingMonth.revenue += opp.value || 0;
  //         } else {
  //             acc.push({ month, revenue: opp.value || 0 });
  //         }

  //         return acc;
  //     }, []);

  //     return { totalValue, funnelData, forecastData };
  // };

  
  
  const checkAndCreateCustomer = async (customerName) => {
    try {
      const response = await axios8001.post('/check_and_create_customer', {
        user_id: sessionStorage.getItem('user_id'),
        api_key: sessionStorage.getItem('api_key'),
        customer_name: customerName,
      });
      console.log('Customer created:', response.data); // Debugging log
      return response.data.customer_id;
    } catch (error) {
      console.error('Error creating customer:', error);
      setError('Failed to create or fetch the customer.');
      return null;
    }
  };

  const checkAndCreateOpportunity = async (customerId, formData) => {
    try {
      const userId = sessionStorage.getItem('user_id');
      const apiKey = sessionStorage.getItem('api_key');
  
      // Validation for session credentials
      if (!userId || !apiKey) {
        console.error('User ID or API Key is missing.');
        setError('User ID or API Key is missing. Please log in again.');
        return null;
      }
  
      // Safely destructure formData
      const customerName = formData?.customerName?.trim();
      const leadDetails = formData?.leadDetails?.trim();
      const opportunityName = formData?.opportunityName?.trim();
  
      // Resolve opportunity name
      const resolvedOpportunityName = opportunityName || leadDetails;
  
      if (!resolvedOpportunityName) {
        console.error('Opportunity name or lead details are missing.');
        setError('Either Opportunity Name or Lead Details is mandatory.');
        return null;
      }
  
      console.log('Resolved Opportunity Name:', resolvedOpportunityName); // Debugging log
  
      // Send request to check and create the opportunity
      const opportunityResponse = await axios8001.post('/check_and_create_opportunity', {
        user_id: userId,
        api_key: apiKey,
        opportunity_name: resolvedOpportunityName,
        customer_id: customerId,
        customer_name: customerName,
      });
  
      const opportunityData = opportunityResponse.data;
  
      if (!opportunityData?.opportunity_id) {
        console.error('Opportunity creation failed.');
        setError('Failed to create or fetch the Opportunity.');
        return null;
      }
  
      console.log('Opportunity created or fetched successfully:', opportunityData.opportunity_id);
      return opportunityData.opportunity_id;
    } catch (error) {
      console.error('Error creating or fetching the opportunity:', error);
  
      // Parse error for more user-friendly messages
      const errorMessage =
        error.response?.data?.message ||
        'An unexpected error occurred. Please check your input and try again.';
      setError(errorMessage);
      return null;
    }
  };
  
/* This is combined function used to check and create customer and then check and create opportunity using inputs from lead name or opportunity name */
const handleOpportunitySubmission = async (formData, isLead = false) => {
  try {
    setLoading(true);
    setError(null);

    // Check and create customer if necessary
    const customerId = await checkAndCreateCustomer(formData.customerName);
    if (!customerId) {
      console.error('Failed to create customer.');
      return;
    }

    // Differentiate between Lead or Qualified Opportunity and Opportunity
    const resolvedOpportunityName = isLead ? formData.leadDetails : formData.opportunityName;

    if (!resolvedOpportunityName) {
      console.error('Opportunity Name or Lead Details is missing.');
      setError('Either Opportunity Name or Lead Details is mandatory.');
      return;
    }

    // Check and create opportunity
    const opportunityId = await checkAndCreateOpportunity(customerId, {
      ...formData,
      opportunityName: resolvedOpportunityName, // Ensure the resolved name is passed
    });

    if (!opportunityId) {
      console.error('Failed to create opportunity.');
      return;
    }

    alert(`${isLead ? 'Lead' : 'Opportunity'} created successfully!`);
    closeModal(); // Close modal after successful operation
  } catch (error) {
    console.error('Error handling opportunity submission:', error);
    alert('An unexpected error occurred. Please try again.');
  } finally {
    setLoading(false);
  }
};


  const tiles = [
    { id: "createOpportunity", name: "Save Leads", description: "Save leads or qualified opportunities.", icon: "📌" },
    { id: "meddicc-help", name: "MEDDICC Help", description: "Learn about the MEDDICC framework.", icon: "📘" },
    { id: "createCustomer", name: "Create Account", description: "Create a customer account for tracking opportunities.", icon: "🏢" },
    { id: "analyzeWhys", name: "Analyze Opportunity Whys", description: "Analyze why opportunities matter.", icon: "🔍" },
    { id: "tryValuePyramid", name: "Try Value Pyramid", description: "Generate value pyramids for accounts.", icon: "🔺" },
  ];
  
  
  // 
  
  
  // const handleOpenModal = (buttonId) => {
  //   if (buttonId === "ask-coach") {
  //     setShowAskCoachTile(true);
  //     setChatMessages([
  //       {
  //         role: "assistant",
  //         content: "Hi! How can I assist you today? Choose an option above or type your question below.",
  //       },
  //     ]); // Add default assistant message
  //     return;
  //   }
  
  //   const modalMapping = {
  //     "identify-leads": "Lead or Qualified Opportunity",
  //     "meddicc-help": "helpMEDDICC",
  //     "create-account": "createCustomer",
  //     "analyze-opportunity": "analyseWhys",
  //   };
  
  //   const selectedModalType = modalMapping[buttonId];
  //   if (selectedModalType) {
  //     setModalType(selectedModalType);
  //   } else {
  //     console.warn(`No modal mapped for button ID: ${buttonId}`);
  //   }
  // };
  
  let modalTimeout;

const handleOpenModal = (buttonId) => {
  if (modalTimeout) return; // Prevent multiple calls

  modalTimeout = setTimeout(() => {
    const modalMapping = {
      createOpportunity: "createOpportunity",
      "meddicc-help": "helpMEDDICC",
      createCustomer: "createCustomer",
      analyzeWhys: "analyseWhys",
      tryValuePyramid: "tryValuePyramid",
    };

    const selectedModalType = modalMapping[buttonId];
    if (selectedModalType) {
      console.log(`Opening modal: ${selectedModalType}`);
      setModalType(selectedModalType); // Set modal type
      setModalOpen(true); // Open modal
    } else {
      console.warn(`No modal mapped for button ID: ${buttonId}`);
    }
    modalTimeout = null; // Reset timeout
  }, 200); // Debounce for 200ms
};


  const fetchOpportunityId = async (customerId, opportunityName, userId, apiKey) => {
    try {
      const response = await axios8001.get("/get_opportunity_id", {
        params: { customer_id: customerId, opportunity_name: opportunityName, user_id: userId, api_key: apiKey },
      });
      const opportunityId = response.data.opportunity_id;
      if (!opportunityId) {
        console.warn(`No Opportunity ID found for ${opportunityName} under Customer ID: ${customerId}`);
      }
      return opportunityId || null;
    } catch (error) {
      console.error("Error fetching opportunity ID:", error.message);
      return null;
    }
  };
  


  

  

  const handleSendMessage = async () => {
    setError(''); // Reset error messages
    const trimmedInput = inputValue.trim();

    // Validate input
    if (!trimmedInput) {
        setError('Message cannot be empty.');
        return;
    }

    // Retrieve user credentials from session storage
    const userId = sessionStorage.getItem('user_id');
    const apiKey = sessionStorage.getItem('api_key');

    // Validate user credentials
    if (!userId || !apiKey) {
        setError('User ID or API Key is missing. Please log in again.');
        return;
    }

    // Add the user's message to the chat
    setMessages((prev) => [...prev, { text: trimmedInput, sender: 'user' }]);
    setInputValue(''); // Clear the input field
    setIsSending(true); // Set sending state

    try {
        // Prepare the payload for the backend
        const messagePayload = {
            user_id: userId,
            user_query: trimmedInput,
            button_str: 'Evaluate Opportunity with MEDDICC Score',
            api_key: apiKey,
        };

        console.log('Sending payload to /direct-chat:', messagePayload); // Debugging log

        // Send the request to the backend
        const response = await axios8000.post('/direct-chat', messagePayload);

        // Handle the backend response
        if (response.data && response.data.response) {
            setMessages((prev) => [...prev, { text: response.data.response, sender: 'bot' }]);
        } else {
            console.warn('Unexpected response format:', response.data); // Debugging log
            setMessages((prev) => [
                ...prev,
                { text: 'Received an unexpected response. Please try again.', sender: 'bot' },
            ]);
        }
    } catch (error) {
        // Log the error for debugging
        console.error('Error interacting with /direct-chat:', error);

        // Handle error scenarios
        const errorMessage =
            error.response?.data?.message || 'Something went wrong. Please try again later.';
        setMessages((prev) => [...prev, { text: errorMessage, sender: 'bot' }]);
    } finally {
        setIsSending(false); // Reset sending state
    }
};

  const handleAnalyseMeddicc = async () => {
    try {
      const userId = sessionStorage.getItem('user_id');
      const apiKey = sessionStorage.getItem('api_key');
  
      if (!userId || !apiKey) {
        setError('User ID or API Key is missing.');
        return;
      }
  
      const payload = {
        user_id: userId,
        api_key: apiKey,
        meddicc_statements: Object.fromEntries(
          Object.keys(formData)
            .filter((key) => key.startsWith('statement_'))
            .map((key) => [key.replace('statement_', ''), formData[key]])
        ),
        meddicc_validations: Object.fromEntries(
          Object.keys(formData)
            .filter((key) => key.startsWith('validation_'))
            .map((key) => [key.replace('validation_', ''), formData[key]])
        ),
        opportunity_contacts: formData.contact?.trim() || '',
        opportunity_contacts_persona: formData.persona?.trim() || '',
        opportunity_source: formData.leadSource?.trim() || '',
      };
  
      console.log('Analyzing MEDDICC with payload:', payload); // Debugging log
  
      const response = await axios8000.post('/direct-chat', payload);
      console.log('MEDDICC Analysis Response:', response.data);
  
      alert('Analysis complete! Check the response in the console.');
    } catch (error) {
      console.error('Error during MEDDICC analysis:', error);
      setError('An error occurred while analyzing MEDDICC.');
    }
  };
  
  const handleSave = async () => {
    setError('');
  
    // Validate form fields
    if (!formData.customerName?.trim()) {
      setError('Customer Name is mandatory.');
      return;
    }
  
    setLoading(true);
    try {
      // Step 1: Check and create the customer
      const customerId = await checkAndCreateCustomer(formData.customerName.trim());
      if (!customerId) throw new Error('Customer creation failed.');
  
      console.log('Customer ID:', customerId); // Debugging log
  
      // Successfully saved
      alert('Saved successfully!');
      closeModal();
    } catch (error) {
      console.error('Error qualifying lead:', error);
      setError('An error occurred while qualifying the lead. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  
  const handleSaveOpportunity = async () => {
    setError('');
  
    // Validate form fields
    if (!formData.customerName?.trim()) {
      setError('Customer Name is mandatory.');
      return;
    }
  
    if (!formData.opportunityName?.trim() && !formData.leadDetails?.trim()) {
      setError('Either Opportunity Name or Lead Details is mandatory.');
      return;
    }
  
    setLoading(true);
    try {
      // Step 1: Check and create the customer
      const customerId = await checkAndCreateCustomer(formData.customerName.trim());
      if (!customerId) throw new Error('Customer creation failed.');
  
      console.log('Customer ID:', customerId); // Debugging log
  
      // Step 2: Check and create the opportunity using the customer ID
      const opportunityId = await checkAndCreateOpportunity(customerId, formData);
      if (!opportunityId) throw new Error('Opportunity creation failed.');
  
      console.log('Opportunity ID:', opportunityId); // Debugging log
  
      // Successfully saved
      alert('Saved successfully!');
      closeModal();
    } catch (error) {
      console.error('Error qualifying lead:', error);
      setError('An error occurred while qualifying the lead. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  
  
  // const closeModal = () => {
  //   setModalType(null);
  //   setFormData({
  //     customerName: '',
  //     leadDetails: '',
  //     opportunityName: '',
  //     accountPlanName: '',
  //     contact: '',
  //     persona: '',
  //     leadSource: '',
  //   });
  //   setError('');
  // };
  
  
  // const getModalTitle = () => {
  //   switch (modalType) {
  //     case "askCoach":
  //     return "Ask Coach";
  //     case 'createAccountPlan':
  //       return 'Create Account Plan';
  //     case 'createOpportunity':
  //       return 'Do you have a lead or a qualified opportunity';
  //     case 'Lead or Qualified Opportunity':
  //         return 'Do you have a lead or a qualified opportunity';
  //     case 'helpMEDDICC':
  //       return 'Help Understanding MEDDICC';
  //     case 'createCustomer':
  //       return 'Create Customer';
  //     case 'analyseWhys':
  //       return 'Analyze Opportunity Whys';
  //     default:
  //       console.warn('Unhandled modal type:', modalType);
  //       return 'Unknown Modal';
  //   }
  // };
  
  
  


  

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const validExtensions = ['ppt', 'pptx', 'pdf'];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (!validExtensions.includes(fileExtension)) {
        setError('Invalid file type. Only PowerPoint (.ppt, .pptx) or PDF files are allowed.');
        return;
      }
      setFormData((prev) => ({ ...prev, file }));
    }
  };
  
  
  const handleAnalyseWhys = async () => {
    try {
      const userId = sessionStorage.getItem('user_id');
      const apiKey = sessionStorage.getItem('api_key');
  
      if (!userId || !apiKey) {
        setError('User ID or API Key is missing.');
        return;
      }
  
      const formDataPayload = new FormData();
      formDataPayload.append('user_id', userId);
      formDataPayload.append('api_key', apiKey);
  
      // Append form data
      if (formData.whyAnything) formDataPayload.append('whyAnything', formData.whyAnything);
      if (formData.whyThisSolution) formDataPayload.append('whyThisSolution', formData.whyThisSolution);
      if (formData.whyNow) formDataPayload.append('whyNow', formData.whyNow);
  
      // Append file if uploaded
      if (formData.file) formDataPayload.append('file', formData.file);
  
      // Send data to the server
      const response = await axios8000.post('/direct-chat', formDataPayload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      console.log('Analysis response:', response.data);
  
      // Update the chat messages area with the analysis response
      setMessages((prev) => [
        ...prev,
        { text: 'Analysis Complete. See the results below:', sender: 'bot' },
        { text: response.data.response, sender: 'bot' },
      ]);
    } catch (error) {
      console.error('Error analyzing opportunity whys:', error);
      setError('An error occurred while analyzing opportunity whys. Please try again.');
    }
  };
  const buttonStyles = (type) => {
    const styles = {
      primary: {
        padding: '10px 15px',
        margin: '0 5px',
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        cursor: 'pointer',
      },
      success: {
        padding: '10px 15px',
        margin: '0 5px',
        backgroundColor: '#28a745',
        color: 'white',
        border: 'none',
        cursor: 'pointer',
      },
      danger: {
        padding: '10px 15px',
        margin: '0 5px',
        backgroundColor: '#dc3545',
        color: 'white',
        border: 'none',
        cursor: 'pointer',
      },
    };
    return styles[type];
  };
  const renderMessages = () => {
    return messages.map((msg, index) => (
      <div
        key={index}
        className={msg.sender === 'bot' ? 'message-bot' : 'message-user'}
      >
        {msg.text}
      </div>
    ));
  };


  const modalMapping = {
    "createOpportunity": "createOpportunity",
    "Save Leads": "SaveLeadorQualifiedOpportunity",
    "meddicc-help": "helpMEDDICC",
    "createCustomer": "createCustomer",
    "analyzeWhys": "analyseWhys",
    "tryValuePyramid": "tryValuePyramid",
    "createOpportunity": "createOpportunity",
    "createAccountPlan": "createAccountPlan",
  };
  
  const getModalTitle = () => {
    const titles = {
      createOpportunity: "Create Opportunity",
      createAccountPlan: "Create Account Plan",
      createOpportunity: "Create Opportunity",
      SaveLeadorQualifiedOpportunity: "Save Leads",
      helpMEDDICC: "MEDDICC Help",
      createCustomer: "Create Account",
      analyseWhys: "Analyze Opportunity Whys",
      tryValuePyramid: "Try Value Pyramid",
    };
  
    return titles[modalType] || "Unknown Modal";
  };
  
  
    
    
  const renderFormElements = () => {
    switch (modalType) {
      case 'createAccountPlan':
        return (
          <form onSubmit={handleAccountPlanSubmit}>
            <div className="form-group">
              <label htmlFor="customerName">Customer Name</label>
              <input
                type="text"
                id="customerName"
                value={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="contact">Contact</label>
              <input
                type="text"
                id="contact"
                value={contact}
                onChange={(e) => setContact(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="industry">Industry</label>
              <input
                type="text"
                id="industry"
                value={industry}
                onChange={(e) => setIndustry(e.target.value)}
              />
            </div>
            {[
              "ACCOUNT HEALTH ASSESSMENT",
              "VALUE PYRAMID",
              "MACRO ECONOMIC & INDUSTRY TRENDS",
              "BUSINESS ISSUES & OBJECTIVES",
              "RELATIONSHIP MAPPING",
              "WHITESPACE MAPPING",
              "VALUE MAPPING",
              "ACTIONABLE QTR BY QTR PLAN",
              "All Execution",
              "Next Steps",
            ].map((section) => (
              <div className="form-group" key={section}>
                <label>{section}</label>
                <textarea
                  rows="3"
                  value={sections[section] || ""}
                  onChange={(e) =>
                    setSections({ ...sections, [section]: e.target.value })
                  }
                  placeholder={`Enter details for ${section}`}
                />
              </div>
            ))}
          </form>
        );
        case 'tryValuePyramid':
  return (
    <>
      {[
        { id: 'customerName', label: 'Customer Name', required: true },
        { id: 'industry', label: 'Industry' },
        { id: 'persona', label: 'Persona' },
        { id: 'solutionType', label: 'Solution Type' },
        { id: 'vendor', label: 'Vendor' },
      ].map(({ id, label, required }) => (
        <div className="form-group" key={id}>
          <label htmlFor={id}>
            {label}
            {required && <span style={{ color: 'red' }}>*</span>}
          </label>
          <input
            type="text"
            id={id}
            value={formData[id] || ''}
            onChange={(e) => handleInputChange(id, e.target.value)}
            required={required}
            placeholder={`Enter ${label}`}
          />
        </div>
      ))}
    </>
  );


          case 'SaveLeadorQualifiedOpportunity':
            return (
              <>
                <label style={{ color: 'white' }}>Customer Name</label>
                <input
                  type="text"
                  value={formData.customerName}
                  onChange={(e) => handleInputChange('customerName', e.target.value)}
                  placeholder="Enter Customer Name"
                  aria-label="Customer Name"
                />
                <label style={{ color: 'white' }}>Lead Details</label>
                <input
                  type="text"
                  value={formData.leadDetails}
                  onChange={(e) => handleInputChange('leadDetails', e.target.value)}
                  placeholder="Enter Lead Details"
                  aria-label="Lead Details"
                />
                <label style={{ color: 'white' }}>Opportunity Name</label>
                <input
                  type="text"
                  value={formData.opportunityName}
                  onChange={(e) => handleInputChange('opportunityName', e.target.value)}
                  placeholder="Enter Opportunity Name"
                  aria-label="Opportunity Name"
                />
                <label style={{ color: 'white' }}>Persona</label>
                <input
                  type="text"
                  value={formData.persona}
                  onChange={(e) => handleInputChange('persona', e.target.value)}
                  placeholder="Enter Persona"
                  aria-label="Persona"
                />
                <label style={{ color: 'white' }}>Lead Source</label>
                <select
                  value={formData.leadSource}
                  onChange={(e) => handleInputChange('leadSource', e.target.value)}
                  aria-label="Lead Source"
                >
                  <option value="" disabled>
                    Select Lead Source
                  </option>
                  <option value="email">Email</option>
                  <option value="phone">Phone</option>
                  <option value="reference">Reference</option>
                  <option value="direct contact">Direct Contact</option>
                  <option value="conference">Conference</option>
                </select>
                <label style={{ color: 'white' }}>Commit Date</label>
                <input
                  type="date"
                  value={formData.commitDate}
                  onChange={(e) => handleInputChange('commitDate', e.target.value)}
                  aria-label="Commit Date"
                />
                <label style={{ color: 'white' }}>Value (in dollars)</label>
                <input
                  type="number"
                  value={formData.value}
                  onChange={(e) => handleInputChange('value', e.target.value)}
                  placeholder="Enter Value"
                  aria-label="Value"
                />
              </>
            );
          
            case 'createOpportunity':
              return (
                <>
                  <label style={{ color: 'white' }}>Customer Name</label>
                  <input
                    type="text"
                    value={formData.customerName}
                    onChange={(e) => handleInputChange('customerName', e.target.value)}
                    placeholder="Enter Customer Name"
                    aria-label="Customer Name"
                  />
                  <label style={{ color: 'white' }}>Lead Details</label>
                  <input
                    type="text"
                    value={formData.leadDetails}
                    onChange={(e) => handleInputChange('leadDetails', e.target.value)}
                    placeholder="Enter Lead Details"
                    aria-label="Lead Details"
                  />
                  <label style={{ color: 'white' }}>Opportunity Name</label>
                  <input
                    type="text"
                    value={formData.opportunityName}
                    onChange={(e) => handleInputChange('opportunityName', e.target.value)}
                    placeholder="Enter Opportunity Name"
                    aria-label="Opportunity Name"
                  />
                  <label style={{ color: 'white' }}>Persona</label>
                  <input
                    type="text"
                    value={formData.persona}
                    onChange={(e) => handleInputChange('persona', e.target.value)}
                    placeholder="Enter Persona"
                    aria-label="Persona"
                  />
                  <label style={{ color: 'white' }}>Lead Source</label>
                  <select
                    value={formData.leadSource}
                    onChange={(e) => handleInputChange('leadSource', e.target.value)}
                    aria-label="Lead Source"
                  >
                    <option value="" disabled>
                      Select Lead Source
                    </option>
                    <option value="email">Email</option>
                    <option value="phone">Phone</option>
                    <option value="reference">Reference</option>
                    <option value="direct contact">Direct Contact</option>
                    <option value="conference">Conference</option>
                  </select>
                  <label style={{ color: 'white' }}>Commit Date</label>
                  <input
                    type="date"
                    value={formData.commitDate}
                    onChange={(e) => handleInputChange('commitDate', e.target.value)}
                    aria-label="Commit Date"
                  />
                  <label style={{ color: 'white' }}>Value (in dollars)</label>
                  <input
                    type="number"
                    value={formData.value}
                    onChange={(e) => handleInputChange('value', e.target.value)}
                    placeholder="Enter Value"
                    aria-label="Value"
                  />
                </>
              );
            
           
  
      case 'createCustomer':
        return (
          <>
            <label style={{ color: 'white' }}>Customer Name</label>
            <input
              type="text"
              value={formData.customerName}
              onChange={(e) => handleInputChange('customerName', e.target.value)}
              placeholder="Enter Customer Name"
              aria-label="Customer Name"
            />
            
            <label style={{ color: 'white' }}>Account Plan Name</label>
            <input
              type="text"
              value={formData.accountPlanName}
              onChange={(e) => handleInputChange('accountPlanName', e.target.value)}
              placeholder="Enter Account Plan Name"
              aria-label="Account Plan Name"
            />
          </>
        );
  
      case 'helpMEDDICC':
        return (
          <div className="meddicc-modal">
            <div
              className="meddicc-container"
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '20px',
              }}
            >
              {['Metrics', 'Economic Buyer', 'Decision Criteria', 'Decision Process', 'Identify Pain', 'Champion', 'Competition'].map(
                (letter, index) => (
                  <React.Fragment key={index}>
                    <div className="meddicc-section">
                      <label style={{ color: 'white', fontWeight: 'bold' }}>{letter}</label>
                      <textarea
                        value={formData[`statement_${letter}`] || ''}
                        onChange={(e) => handleInputChange(`statement_${letter}`, e.target.value)}
                        placeholder={`Enter statement for ${letter}`}
                        aria-label={`Statement for ${letter}`}
                        style={{
                          width: '100%',
                          height: '80px',
                          resize: 'none',
                          marginBottom: '10px',
                        }}
                      />
                    </div>
                    <div className="meddicc-section">
                      <label style={{ color: 'white', fontWeight: 'bold' }}>Validation for {letter}</label>
                      <textarea
                        value={formData[`validation_${letter}`] || ''}
                        onChange={(e) => handleInputChange(`validation_${letter}`, e.target.value)}
                        placeholder={`Enter validation for ${letter}`}
                        aria-label={`Validation for ${letter}`}
                        style={{
                          width: '100%',
                          height: '80px',
                          resize: 'none',
                          marginBottom: '10px',
                        }}
                      />
                    </div>
                  </React.Fragment>
                )
              )}
            </div>
          </div>
        );
  
        case 'analyseWhys':
          return (
            <div className="analyse-whys-modal">
              <label style={{ color: 'white', fontWeight: 'bold' }}>Why Anything</label>
              <textarea
                value={formData.whyAnything || ''}
                onChange={(e) => handleInputChange('whyAnything', e.target.value)}
                placeholder="Explain why the customer should consider any solution"
                aria-label="Why Anything"
                style={{ width: '100%', height: '80px', resize: 'none', marginBottom: '10px' }}
              />
              <label style={{ color: 'white', fontWeight: 'bold' }}>Why This Solution</label>
              <textarea
                value={formData.whyThisSolution || ''}
                onChange={(e) => handleInputChange('whyThisSolution', e.target.value)}
                placeholder="Explain why this solution is the right choice"
                aria-label="Why This Solution"
                style={{ width: '100%', height: '80px', resize: 'none', marginBottom: '10px' }}
              />
              <label style={{ color: 'white', fontWeight: 'bold' }}>Why Now</label>
              <textarea
                value={formData.whyNow || ''}
                onChange={(e) => handleInputChange('whyNow', e.target.value)}
                placeholder="Explain why the customer should act now"
                aria-label="Why Now"
                style={{ width: '100%', height: '80px', resize: 'none', marginBottom: '10px' }}
              />
              <label style={{ color: 'white', fontWeight: 'bold' }}>Upload Opportunity Whys (PowerPoint or PDF)</label>
              <input
                type="file"
                accept=".ppt,.pptx,.pdf"
                onChange={(e) => handleFileUpload(e)}
                style={{ color: 'white', marginBottom: '10px' }}
              />
            </div>
          );
        } 
  };
  
  
    
  const renderModal = () => {
    if (!isModalOpen || !modalType) return null;
  console.log(`renderModal called. isModalOpen: ${isModalOpen}, modalType: ${modalType}`);
    
    // Footer button rendering based on modal type
    const renderFooterButtons = () => {
      switch (modalType) {
        case 'createAccountPlan':
      return (
        <>
          <button
            onClick={handleAnalyzeAccountPlan}
            disabled={!formData.customerName || loading}
            className="btn-primary"
            style={buttonStyles('primary')}
          >
            {loading ? 'Analyzing...' : 'Analyze Account Plan'}
          </button>
          <button
            onClick={handleAccountPlanSubmit}
            disabled={!formData.customerName || loading}
            className="btn-success"
          >
            {loading ? 'Submitting...' : 'Submit'}
          </button>
          <button
            onClick={closeModal}
            className="btn-cancel"
            style={buttonStyles('danger')}
          >
            Cancel
          </button>
        </>
      );
        case 'helpMEDDICC':
          return (
            <>
              <button
                className="btn-analyze"
                onClick={handleAnalyseMeddicc}
                style={buttonStyles('primary')}
              >
                Analyze MEDDICC
              </button>
              <button
                onClick={closeModal}
                className="btn-cancel"
                style={buttonStyles('danger')}
              >
                Cancel
              </button>
            </>
          );
        case 'analyseWhys':
          return (
            <>
              <button
                className="btn-analyze"
                onClick={handleAnalyseWhys}
                style={buttonStyles('primary')}
              >
                Analyze Opportunity Whys
              </button>
              <button
                onClick={closeModal}
                className="btn-cancel"
                style={buttonStyles('danger')}
              >
                Cancel
              </button>
            </>
          );
        case 'tryValuePyramid':
          return (
            <>
              <button
                onClick={handleGenerateValuePyramid}
                disabled={!formData.customerName || loading}
                className="btn-primary"
                style={buttonStyles('primary')}
              >
                {loading ? 'Generating...' : 'Generate Value Pyramid'}
              </button>
              <button
                onClick={closeModal}
                className="btn-cancel"
                style={buttonStyles('danger')}
              >
                Cancel
              </button>
            </>
          );
          case 'createOpportunity':
            return (
              <>
                <button
                  onClick={() => handleOpportunitySubmission(formData, false)}
                  disabled={!formData.opportunityName || loading}
                  className="btn-primary"
                  style={buttonStyles('primary')}
                >
                  {loading ? 'Creating...' : 'Create Opportunity'}
                </button>
                <button
                  onClick={closeModal}
                  className="btn-cancel"
                  style={buttonStyles('danger')}
                >
                  Cancel
                </button>
              </>
            );
          case 'SaveLeadOrQualifiedOpportunity':
            return (
              <>
                <button
                  onClick={() => handleOpportunitySubmission(formData, true)}
                  disabled={!formData.customerName || loading}
                  className="btn-primary"
                  style={buttonStyles('primary')}
                >
                  {loading ? 'Processing...' : 'Save Lead/Opportunity'}
                </button>
                <button
                  onClick={closeModal}
                  className="btn-cancel"
                  style={buttonStyles('danger')}
                >
                  Cancel
                </button>
              </>
            );
            case 'createCustomer':
              return (
                <>
                  <button
                    onClick={handleSave}
                    disabled={!formData.customerName || loading}
                    className="btn-primary"
                    style={buttonStyles('primary')}
                  >
                    {loading ? 'Creating...' : 'Create Customer'}
                  </button>
                  <button
                    onClick={closeModal}
                    className="btn-cancel"
                    style={buttonStyles('danger')}
                  >
                    Cancel
                  </button>
                </>
              );
            
        default:
          return null;
      }
    };
    
    
  
    // Form rendering logic for `tryValuePyramid`
    const renderTryValuePyramidForm = () => (
      <>
        {[
          { id: 'customerName', label: 'Customer Name', required: true },
          { id: 'industry', label: 'Industry' },
          { id: 'persona', label: 'Persona' },
          { id: 'solutionType', label: 'Solution Type' },
          { id: 'vendor', label: 'Vendor' },
        ].map(({ id, label, required }) => (
          <div className="form-group" key={id}>
            <label htmlFor={id}>
              {label}
              {required && <span style={{ color: 'red' }}>*</span>}
            </label>
            <input
              type="text"
              id={id}
              value={formData[id] || ''}
              onChange={(e) => handleInputChange(id, e.target.value)}
              required={required}
              placeholder={`Enter ${label}`}
            />
          </div>
        ))}
      </>
    );
  
    // Dynamically render form content
    const renderFormContent = () => {
      switch (modalType) {
        case 'tryValuePyramid':
          return renderTryValuePyramidForm();
        default:
          return renderFormElements(); // Render other modal types dynamically
      }
    };
  
    
      return (
        <div className="modal-overlay" role="dialog" aria-modal="true">
          <div className="modal-content" style={{ backgroundColor: '#001F3F' }}>
            {/* Modal Header */}
            <div className="modal-header">
              <h3 id="modalTitle" style={{ color: 'white' }}>{getModalTitle()}</h3>
              <button
                className="modal-close-btn"
                onClick={closeModal}
                style={{ background: 'transparent', color: 'white', border: 'none', fontSize: '1.5rem', cursor: 'pointer' }}
                aria-label="Close Modal"
              >
                &times;
              </button>
            </div>
    
            {/* Modal Body */}
            <div className="modal-body">{renderFormContent()}</div>
    
            {/* Error Message */}
            {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
    
            {/* Modal Footer */}
            <div className="modal-footer">{renderFooterButtons()}</div>
          </div>
        </div>
      );
    };
  
  
  /* Value Pyramid Tile code*/

  useEffect(() => {
    console.log(`Modal State Updated: isModalOpen: ${isModalOpen}, modalType: ${modalType}`);
  }, [isModalOpen, modalType]);
  
  useEffect(() => {
    console.log(`Form Data Updated:`, formData);
  }, [formData]);
  
  
  
  // const handleGenerateValuePyramid = async () => {
  //   setLoading(true);
  
  //   const userId = sessionStorage.getItem('user_id');
  //   const apiKey = sessionStorage.getItem('api_key');
  //   const customerName = formData.customerName;
  
  //   if (!userId || !apiKey || !customerName) {
  //     alert('User ID, API Key, or Customer Name is missing.');
  //     setLoading(false);
  //     return;
  //   }
  
  //   try {
  //     // Step 1: Retrieve customer_id
  //     const customerResponse = await axios8001.get(`/get_customer_details`, {
  //       params: { customer_name: customerName },
  //     });
  
  //     const customerId = customerResponse.data.customer_id;
  //     if (!customerId) {
  //       throw new Error('Failed to retrieve customer_id');
  //     }
  
  //     // Step 2: Retrieve account_id
  //     const accountResponse = await axios8001.get(`/get_account_id`, {
  //       params: { customer_id: customerId, account_name: customerName },
  //     });
  
  //     const accountId = accountResponse.data.account_id || ''; // Default to empty if not found
  
  //     // Step 3: Navigate immediately to the Value Pyramid page with a "processing" state
  //     const queryString = `?user_id=${encodeURIComponent(userId)}&api_key=${encodeURIComponent(apiKey)}&customer_name=${encodeURIComponent(customerName)}&solution_type=${encodeURIComponent(formData.solutionType)}&vendor_names=${encodeURIComponent(formData.vendor)}&processing=true`;
  //     navigate(`/valuepyramid/${accountId}${queryString}`);
  
  //     // Step 4: Make the POST request to build-value-pyramid in the background
  //     await axios8300.post('/build-value-pyramid/', {
  //       user_id: userId,
  //       api_key: apiKey,
  //       account_id: accountId,
  //       customer_name: customerName,
  //       industry: formData.industry || null,
  //       solution_type: formData.solutionType || null,
  //       vendor_names: formData.vendor ? [formData.vendor] : [],
  //       layer: '',
  //       data: {},
  //       layer_updates: {},
  //     });
  
  //     console.log('Value Pyramid generation request submitted successfully!');
  //   } catch (error) {
  //     console.error('Error generating Value Pyramid:', error);
  //     alert('Failed to generate Value Pyramid. Please check the backend logs for more details.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  
const [loading, setLoading] = useState(false);
const [pyramidData, setPyramidData] = useState(null);

  // Updated function
// const handleGenerateValuePyramid = async () => {
//   setLoading(true);

//   const userId = sessionStorage.getItem('user_id');
//   const apiKey = sessionStorage.getItem('api_key');
//   const customerName = formData.customerName;

//   if (!userId || !apiKey || !customerName) {
//       alert('User ID, API Key, or Customer Name is missing.');
//       setLoading(false);
//       return;
//   }

//   try {
//       // Step 1: Retrieve customer_id
//       const customerResponse = await axios8001.get(`/get_customer_details`, {
//           params: { customer_name: customerName },
//       });

//       const customerId = customerResponse.data.customer_id;
//       if (!customerId) {
//           throw new Error('Failed to retrieve customer_id');
//       }

//       // Step 2: Retrieve account_id
//       const accountResponse = await axios8001.get(`/get_account_id`, {
//           params: { customer_id: customerId, account_name: customerName },
//       });

//       const accountId = accountResponse.data.account_id || '';

//       // Step 3: Make the POST request to build-value-pyramid
//       const buildResponse = await axios8300.post('/build-value-pyramid/', {
//           user_id: userId,
//           api_key: apiKey,
//           account_id: accountId,
//           customer_name: customerName,
//           industry: formData.industry || null,
//           solution_type: formData.solutionType || null,
//           vendor_names: formData.vendor ? [formData.vendor] : [],
//           layer: '',
//           data: {},
//           layer_updates: {},
//       });

//       if (buildResponse.status === 200) {
//           console.log('Backend Response:', buildResponse.data);
//           alert('Value Pyramid Generated Successfully!');

//           // Navigate to Value Pyramid page and trigger data fetch
//           navigate(`/valuepyramid/${accountId}?success=true`);
//       } else {
//           throw new Error('Backend response indicates failure.');
//       }
//   } catch (error) {
//       console.error('Error generating Value Pyramid:', error);
//       alert('Failed to generate Value Pyramid. Please check the backend logs for more details.');
//   } finally {
//       setLoading(false);
//   }
// };

const handleGenerateValuePyramid = async () => {
  setLoading(true);

  const userId = sessionStorage.getItem('user_id');
  const apiKey = sessionStorage.getItem('api_key');
  const customerName = formData.customerName;

  if (!userId || !apiKey || !customerName) {
    alert('User ID, API Key, or Customer Name is missing.');
    setLoading(false);
    return;
  }

  try {
    // Step 1: Retrieve customer_id
    const customerResponse = await axios8001.get(`/get_customer_details`, {
      params: { customer_name: customerName },
    });

    const customerId = customerResponse.data.customer_id;
    if (!customerId) {
      throw new Error('Failed to retrieve customer_id');
    }

    // Step 2: Retrieve account_id
    const accountResponse = await axios8001.get(`/get_account_id`, {
      params: { customer_id: customerId, account_name: customerName },
    });

    const accountId = accountResponse.data.account_id || '';

    // Step 3: Make an API call to the backend to build the Value Pyramid
    const solutionTypes = formData.solutionType || '';
    const vendorNames = formData.vendor ? [formData.vendor] : [];
    const buildResponse = await axios8300.post('/build-value-pyramid/', {
      user_id: userId,
      api_key: apiKey,
      account_id: accountId,
      customer_name: customerName,
      industry: formData.industry || null,
      solution_type: solutionTypes,
      vendor_names: vendorNames,
    });

    if (buildResponse.status === 200) {
      console.log('Backend Response:', buildResponse.data);
      alert('Value Pyramid Generated Successfully!');

      // Construct URL with all necessary query parameters for navigation
      const queryString = `?user_id=${encodeURIComponent(userId)}&api_key=${encodeURIComponent(apiKey)}&account_id=${encodeURIComponent(accountId)}&solution_types=${encodeURIComponent(solutionTypes)}&vendor_names=${encodeURIComponent(vendorNames.join(','))}`;

      // Navigate to the Value Pyramid page
      navigate(`/valuepyramid/${accountId}${queryString}`);
    } else {
      throw new Error('Backend response indicates failure.');
    }
  } catch (error) {
    console.error('Error generating Value Pyramid:', error);
    alert('Failed to generate Value Pyramid. Please check the backend logs for more details.');
  } finally {
    setLoading(false);
  }
};




// useEffect logic for Value Pyramid page
useEffect(() => {
  fetch("/api/get-value-pyramid")
      .then((response) => response.json())
      .then((data) => {
          setPyramidData(data); // Update state with fetched data
      })
      .catch((error) => {
          console.error("Error fetching Value Pyramid data:", error);
      });
}, []); // Runs on component mount


  
  
  /* user dashboard with account and opportunity metrics */

  // Define state variables
const [selectedAccountId, setSelectedAccountId] = useState(null);
const [accountLearnings, setAccountLearnings] = useState(null);
const [delayedTasks, setDelayedTasks] = useState(null);
const [opportunityMetrics, setOpportunityMetrics] = useState(null);
const [closingProbability, setClosingProbability] = useState(null);
const [opportunityLearnings, setOpportunityLearnings] = useState(null);
/* this is the logic which sends details to apiUtils */
// const [opportunitiesWithIds, setOpportunities] = useState([]);
// useEffect(() => {
//   const fetchOpportunities = async () => {
//     try {
//       const opportunitiesWithIds = await Promise.all(
//         opportunities.map(async (opportunity) => {
//           if (!opportunity.opportunity_id) {
//             const opportunityId = await fetchOpportunityId(
//               customerId, // Pass customerId from context or state
//               opportunity.opportunity_name
//             );
//             return { ...opportunity, opportunity_id: opportunityId };
//           }
//           return opportunity;
//         })
//       );

//       setOpportunities(opportunitiesWithIds);
//     } catch (error) {
//       console.error("Error fetching opportunities:", error);
//     }
//   };

//   fetchOpportunities();
// }, [opportunities]);



const [opportunityData, setOpportunityData] = useState([]);
const [accountIdMap, setAccountIdMap] = useState({});


// Utility function for error handling
const handleError = (error, message) => {
  console.error(message, error);
  setError(message);
};

// Fetch account data
const fetchAccountData = async (customerName, customerId) => {
  try {
    const accountId = await fetchAccountId(customerId, customerName); // Uses the fetchAccountId API function
    setAccountIdMap((prev) => ({ ...prev, [customerName]: accountId })); // Update state

    // Fetch account-related details
    const learnings = await fetchAccountLearnings(accountId);
    const tasks = await fetchDelayedTasksByRole(accountId);

    setAccountLearnings((prev) => ({ ...prev, [customerName]: learnings }));
    setDelayedTasks((prev) => ({ ...prev, [customerName]: tasks }));
  } catch (error) {
    console.error(`Error fetching account data for ${customerName}:`, error);
  }
};

// Fetch opportunities and associate them with customers
// Retrieve user ID and API Key from session storage






// const fetchCustomerAndOpportunities = async () => {
//   try {
//     const userId = sessionStorage.getItem("user_id");
//     const apiKey = sessionStorage.getItem("api_key");

//     if (!userId || !apiKey) {
//       throw new Error("Missing user credentials. Please log in.");
//     }

//     const response = await axios8001.get(`/customer-opportunities`, {
//       params: { user_id: userId },
//     });

//     const customerData = response.data.customer_names_with_opportunities || {};
//     const resolvedData = {};

//     for (const [customerName, opportunities] of Object.entries(customerData)) {
//       const customerId = await fetchCustomerId(customerName);

//       // Fetch account data
//       await fetchAccountData(customerName, customerId);

//       const opportunityDetails = await Promise.all(
//         opportunities.map(async (opportunity) => {
//           const opportunityId = await fetchOpportunityId(customerId, opportunity, userId, apiKey);
//           return {
//             opportunity_name: opportunity,
//             opportunity_id: opportunityId,
//             customer_id: customerId,
//           };
//         })
//       );

//       resolvedData[customerName] = opportunityDetails;
//     }

//     setCustomerOpportunities(resolvedData);
//   } catch (error) {
//     handleError(error, "Error fetching customer and opportunity data.");
//   }
// };
const fetchOpportunityNextSteps = async (opportunityId) => {
  try {
    const response = await axios8200.get(`/suggested_next_steps/${opportunityId}`);
    console.log("Fetched Next Steps for Opportunity:", opportunityId, response.data);
    return response.data?.next_steps || [];
  } catch (error) {
    console.error("Error fetching Opportunity Next Steps:", error.message);
    return [];
  }
};


const fetchCustomerAndOpportunities = async () => {
  if (!userId || !apiKey) {
    console.error("User ID or API Key is missing. Please log in again.");
    return;
  }

  try {
    const response = await axios8001.get(`/customer-opportunities`, { params: { user_id: userId } });
    const customers = response.data?.customer_names_with_opportunities || {};

    const resolvedOpportunities = {};
    const opportunityData = {};

    for (const [customerName, opportunities] of Object.entries(customers)) {
      try {
        const customerId = await fetchCustomerId(customerName);

        const opportunityDetails = await Promise.all(
          opportunities.map(async (opportunity) => {
            try {
              const opportunityId = await fetchOpportunityId(customerId, opportunity, userId, apiKey);
              const [probability, nextSteps, metrics, salesStageHealth] = await Promise.all([
                fetchClosingProbability(opportunityId),
                fetchOpportunityNextSteps(opportunityId), // Fetch next steps here
                fetchOpportunityMetrics(opportunityId),
                fetchSalesStageHealth(opportunityId),
              ]);

              opportunityData[opportunityId] = {
                metrics,
                probability,
                nextSteps, // Ensure nextSteps is added
                salesStageHealth,
              };

              return {
                opportunity_name: opportunity,
                opportunity_id: opportunityId,
                customer_id: customerId,
              };
            } catch (error) {
              console.warn(`Failed to fetch data for ${opportunity}:`, error);
              return null; // Skip this opportunity on error
            }
          })
        );

        resolvedOpportunities[customerName] = opportunityDetails.filter(Boolean);
      } catch (error) {
        console.warn(`Failed to fetch customer ID for ${customerName}:`, error);
      }
    }

    setCustomerOpportunities(resolvedOpportunities);
    setOpportunityData(opportunityData);

    console.log("Resolved Customer Opportunities:", resolvedOpportunities);
    console.log("Fetched Opportunity Data:", opportunityData);
  } catch (error) {
    console.error("Error fetching customer opportunities:", error);
  }
};


// Fetch opportunity-related data when `selectedOpportunityId` changes
// Fetch opportunity-related data for a specific opportunity
const fetchOpportunityData = async (opportunityId) => {
  if (!opportunityId) {
    console.error("Opportunity ID is missing for fetching opportunity data.");
    return;
  }

  try {
    // Fetch all relevant data for the opportunity
    const [metrics, probability, nextSteps, salesStageHealth] = await Promise.all([
      fetchOpportunityMetrics(opportunityId),
      fetchClosingProbability(opportunityId),
      fetchOpportunityNextSteps(opportunityId),
      fetchSalesStageHealth(opportunityId),
    ]);

    // Debug next steps data
    console.log(`Fetched next steps for Opportunity ID: ${opportunityId}`, nextSteps);

    // Update state with the fetched data
    setOpportunityData((prev) => ({
      ...prev,
      [opportunityId]: {
        metrics,
        probability,
        nextSteps, // Add next steps to state
        salesStageHealth,
      },
    }));

    console.log(`Updated state for Opportunity ID: ${opportunityId}`, {
      metrics,
      probability,
      nextSteps,
      salesStageHealth,
    });
  } catch (error) {
    console.error(`Error fetching data for Opportunity ID: ${opportunityId}`, error.message);
  }
};




useEffect(() => {
  if (selectedOpportunityId) {
    fetchOpportunityData(selectedOpportunityId); // Redundant; all data is fetched upfront
  }
}, [selectedOpportunityId]);

// Lifecycle Hook: Fetch data for a specific account when `selectedAccountId` changes
useEffect(() => {
  const fetchSelectedAccountData = async () => {
    if (!selectedAccountId) {
      console.warn("Selected Account ID is missing.");
      return;
    }

    try {
      await fetchAccountData(selectedAccountId);
      console.log(`Fetched data for Account ID: ${selectedAccountId}`);
    } catch (error) {
      handleError(error, `Error fetching data for Account ID: ${selectedAccountId}`);
    }
  };

  fetchSelectedAccountData();
}, [selectedAccountId]);

// Lifecycle Hook: Fetch opportunity details when `selectedOpportunityId` changes
useEffect(() => {
  if (!selectedOpportunityId) {
    console.warn("Selected Opportunity ID is missing.");
    return;
  }

  fetchOpportunityData(selectedOpportunityId);
}, [selectedOpportunityId]);


// Function to open modal with next steps
const openNextStepsModal = (nextSteps) => {
  setModalContent(nextSteps);
  setModalOpen(true);
};



const closeModal = () => {
  setModalType(null);
  resetForm();

  if (modalType === "askCoach") {
    setChatMessages([]); // Clear chat messages for the Ask Coach modal
  }

  if (modalType === "nextSteps") {
    setModalContent(null); // Clear the content for the Next Steps modal
  }

  setError("");
};


// Remove unused `fetchCustomerDetails` function if not required

// API Functions
const fetchAccountLearnings = async (accountId) => {
  try {
    const response = await axios8400.get(`/analyze_learnings/${accountId}`);
    return response.data;
  } catch (error) {
    handleError(error, "Error fetching account learnings.");
    return null;
  }
};

const fetchDelayedTasksByRole = async (accountId) => {
  try {
    const response = await axios8400.get(`/delayed_tasks_by_role/${accountId}`);
    return response.data;
  } catch (error) {
    handleError(error, "Error fetching delayed tasks by role.");
    return null;
  }
};

const fetchOpportunityMetrics = async (opportunityId) => {
  if (!opportunityId) {
    console.error("Opportunity ID is missing for fetching metrics.");
    return null;
  }

  try {
    const response = await axios8200.get(`/task_metrics/${opportunityId}`);
    const metricsData = response.data;

    // Update state for opportunityMetrics
    setOpportunityMetrics((prevMetrics) => ({
      ...prevMetrics,
      [opportunityId]: metricsData, // Ensure the opportunityId is mapped to the metrics
    }));

    console.log(`Fetched and updated metrics for Opportunity ID: ${opportunityId}`, metricsData);
    return metricsData; // Return metrics if needed elsewhere
  } catch (error) {
    console.error(`Error fetching opportunity metrics for ID: ${opportunityId}`, error.message);
    return null;
  }
};




// Fetch a single closing probability by opportunityId
const fetchClosingProbability = async (opportunityId) => {
  if (!opportunityId) {
    console.error("Opportunity ID is missing for fetching closing probability.");
    return { closing_probability: 0 };
  }

  try {
    const response = await axios8200.get(`/closing_probability/${opportunityId}`);
    return response.data?.closing_probability || 0;
  } catch (error) {
    console.error(`Error fetching closing probability for Opportunity ID: ${opportunityId}`, error.message);
    return { closing_probability: 0 }; // Default to 0 on error
  }
};

const fetchSalesStageHealth = async (opportunityId) => {
  if (!opportunityId) {
    console.error("Opportunity ID is missing for fetching sales stage health.");
    return {
      stage: "N/A",
      meddiccHealth: 0,
      complianceScore: 0,
    }; // Default values
  }

  try {
    const response = await axios8200.get(`/sales_stage_health/${opportunityId}`);
    return {
      stage: response.data.sales_stage || "N/A",
      meddiccHealth: response.data.Meddicc_health_score || 0,
      complianceScore: response.data.compliance_score || 0,
    };
  } catch (error) {
    console.error(`Error fetching sales stage health for Opportunity ID: ${opportunityId}`, error);
    return {
      stage: "N/A",
      meddiccHealth: 0,
      complianceScore: 0,
    }; // Default values
  }
};
const fetchOpportunityLearnings = async (opportunityId) => {
  try {
    const response = await axios8200.get(`/opportunity_learnings/${opportunityId}`);
    return response.data;
  } catch (error) {
    handleError(error, "Error fetching opportunity learnings.");
    return null;
  }
};
// Fetch all closing probabilities for opportunities
// Fetch customer opportunities on initial render
useEffect(() => {
  const initializeCustomerOpportunities = async () => {
    try {
      await fetchCustomerAndOpportunities();
    } catch (error) {
      console.error("Error initializing customer opportunities:", error.message);
    }
  };

  initializeCustomerOpportunities();
}, []);

// Fetch opportunity details when `selectedOpportunityId` changes
useEffect(() => {
  if (!selectedOpportunityId) {
    console.warn("Selected Opportunity ID is missing.");
    return;
  }

  fetchOpportunityData(selectedOpportunityId);
}, [selectedOpportunityId]);



// Fetch closing probabilities for all opportunities
// useEffect(() => {
//   const fetchAllClosingProbabilities = async () => {
//     try {
//       const allProbabilities = {};
//       for (const [customerName, opportunities] of Object.entries(customerOpportunities || {})) {
//         for (const opportunity of opportunities) {
//           const probability = await fetchClosingProbability(opportunity.opportunity_id);
//           allProbabilities[opportunity.opportunity_id] = probability * 100; // Convert to percentage
//         }
//       }
//       setClosingProbability(allProbabilities); // State to store all probabilities
//     } catch (error) {
//       console.error("Error fetching closing probabilities:", error);
//     }
//   };

//   if (customerOpportunities) {
//     fetchAllClosingProbabilities();
//   }
// }, [customerOpportunities]);





  // const DashboardButton = ({ label, onClick }) => (
  //   <button onClick={onClick}>{label}</button>
  // ); 
  // const CustomerSection = ({ customerName, opportunities }) => (
  //   <div className="customer-section">
  //     <h4><a href={`/customer/${customerName}`}>{customerName}</a></h4>
  //     <ul>
  //       {opportunities.map((opportunity) => (
  //         <li key={opportunity.opportunity_id}>
  //           <a href={`/opportunity/${opportunity.opportunity_id}`}>{opportunity.opportunity_name}</a>
  //         </li>
  //       ))}
  //     </ul>
  //   </div>
  // );
  // const ChatInput = ({ value, onChange, onSend }) => (
  //   <div className="chat-input-area">
  //     <input type="text" placeholder="Ask any question..." value={value} onChange={onChange} />
  //     <button onClick={onSend}>Send</button>
  //   </div>
  // );
    
  // const [showAccountPlanModal, setShowAccountPlanModal] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [contact, setContact] = useState("");
  const [industry, setIndustry] = useState("");
  const [sections, setSections] = useState({});
  
  // Debugging State Changes
  useEffect(() => {
    console.log("Modal Type:", modalType);
    console.log("Customer Name:", customerName);
    console.log("Contact:", contact);
    console.log("Industry:", industry);
    console.log("Sections:", sections);
  }, [modalType, customerName, contact, industry, sections]);

  useEffect(() => {
    console.log("Current modalType:", modalType);
    console.log("Current formData:", formData);
    console.log("Current sections:", sections);
  }, [modalType, formData, sections]);
  
  // Function to reset form fields
  const resetForm = () => {
    setCustomerName("");
    setContact("");
    setIndustry("");
    setSections({});
    setError("");
  };


  // useEffect(() => {
  //   const fetchAllClosingProbabilities = async () => {
  //     try {
  //       const allProbabilities = {};
  //       for (const [customerName, opportunities] of Object.entries(customerOpportunities || {})) {
  //         for (const opportunity of opportunities) {
  //           const probability = await fetchClosingProbability(opportunity.opportunity_id);
  //           allProbabilities[opportunity.opportunity_id] = probability?.closing_probability || 0;
  //         }
  //       }
  //       setClosingProbability(allProbabilities); // Assuming `closingProbability` is part of state
  //     } catch (error) {
  //       console.error("Error fetching closing probabilities:", error);
  //     }
  //   };
  
  //   if (customerOpportunities) {
  //     fetchAllClosingProbabilities();
  //   }
  // }, [customerOpportunities]);
  // Function to handle account plan submission
  const handleAccountPlanSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      // Fetch customer details
      const customerDetailsResponse = await axios8001.post(
        "/get_customer_details/",
        { customer_name: customerName },
        { headers: { "Content-Type": "application/json" } }
      );

      const customerDetails = customerDetailsResponse.data;
      if (!customerDetails.customer_id) {
        setError("Failed to fetch customer details");
        return;
      }

      // Send account plan details
      const accountPlanResponse = await axios8001.post(
        "/check_and_create_account/",
        {
          customer_id: customerDetails.customer_id,
          contact,
          industry,
          sections,
        },
        { headers: { "Content-Type": "application/json" } }
      );

      const accountPlanResult = accountPlanResponse.data;
      if (accountPlanResult.success) {
        alert("Account Plan created successfully");
        setModalType(null);
        resetForm();
      } else {
        setError("Failed to create Account Plan");
      }
    } catch (err) {
      console.error("Error creating Account Plan:", err);
      setError("An error occurred while creating the Account Plan.");
    } finally {
      setLoading(false);
    }
  };

  // Function to analyze the account plan
  const handleAnalyzeAccountPlan = async () => {
    try {
      const userId = sessionStorage.getItem("user_id");
      const apiKey = sessionStorage.getItem("api_key");
  
      if (!userId || !apiKey) {
        setError("User ID or API Key is missing.");
        return;
      }
  
      // Prepare user_query with form data
      const userQuery = {
        customerName,
        contact,
        industry,
        sections,
      };
  
      // Payload for the request
      const payload = {
        user_id: userId,
        api_key: apiKey,
        button_str: "Build or Review Account Plan",
        user_query: JSON.stringify(userQuery), // Convert form data to a JSON string
      };
  
      console.log("Sending account plan for analysis:", payload);
  
      // Send request to /direct-chat on port 8000
      const response = await axios8000.post("/direct-chat/", payload);
  
      console.log("Analysis Result:", response.data);
  
      // Optionally display response or alert the user
      alert("Analysis completed! Check console for details.");
    } catch (err) {
      console.error("Error analyzing account plan:", err);
      setError("An error occurred while analyzing the account plan.");
    }
  };
   /* assistant-chat-Icon code */
   const chatEndRef = useRef(null);

useEffect(() => {
  chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
}, [chatMessages]);

useEffect(() => {
  const chatContainer = document.querySelector(".chat-container");
  if (chatContainer) {
    chatContainer.scrollTop = chatContainer.scrollHeight;
  }
}, [chatMessages]);





const handleOpenAskCoach = () => {
  setShowAskCoachTile(true);
  setChatMessages([
    { role: "assistant", content: "Hi! How can I assist you today? Choose an option above or type your question below." },
  ]); // Add a default assistant message
};
  
    // Define the contexts for each button
    const contexts = {
      "Lead Next Steps": "Provide personalized next steps for nurturing the lead and progressing the opportunity based on its current stage, MEDDICC alignment, and customer priorities.",
      "Fetch MEDDICC": "Retrieve and validate key MEDDICC components for this opportunity. Highlight missing elements, suggest actions, and provide questions to strengthen alignment.",
      "Competitor Insights": "Analyze potential competitors in this opportunity and suggest strategies to differentiate our solution, including objections to raise against competitors.",
      "Risk Mitigation": "Identify potential risks in this opportunity, such as low engagement or weak champions, and recommend actions to mitigate these risks.",
      "Analyze Tasks": "Assess pending tasks for the opportunity to ensure alignment with sales strategy. Highlight overdue or critical tasks and suggest adjustments for improved progress.",
      "Persona Analysis": "Analyze the personas involved in this opportunity. Highlight their priorities, influence, and engagement level, and suggest tailored messaging and actions.",
    };
  
   // Fetch user details
   // Update User Role
   const updateUserRole = async (userId, apiKey, newRole, setChatMessages) => {
     try {
       // Correct the payload key
       await axios8001.post(`/update_user_role`, { user_id: userId, api_key: apiKey, role: newRole });
       setChatMessages((prevMessages) => [
         ...prevMessages,
         { role: "assistant", content: `Thank you! Your role has been updated to "${newRole}".` },
       ]);
       return newRole;
     } catch (error) {
       console.error("Error updating user role:", error);
       setChatMessages((prevMessages) => [
         ...prevMessages,
         { role: "error", content: "Unable to update your role. Please try again later." },
       ]);
       return null;
     }
   };
   
   
   const [customers, setCustomers] = useState([]);
   
   useEffect(() => {
     const loadCustomers = async () => {
       if (userId && apiKey) {
         const customerData = await fetchCustomerOpportunities(userId, apiKey);
         setCustomers(customerData);
       }
     };
 
     loadCustomers();
   }, [userId, apiKey]);
    
   // Fetch User Details
const fetchUserDetails = async (userId, apiKey, setChatMessages) => {
  try {
    const response = await axios8001.get(`/get_user_details?user_id=${userId}&api_key=${apiKey}`);
    const { role, name, email, default_customer, default_opportunity } = response.data;

    if (!role) {
      setChatMessages((prevMessages) => [
        ...prevMessages,
        { role: "assistant", content: "It seems your role is not set. Please provide your role (e.g., Sales Executive, Sales Engineer, etc.):" },
      ]);
      return null;
    }

    // Log default customer and opportunity for debugging
    console.log("Default Customer:", default_customer);
    console.log("Default Opportunity:", default_opportunity);

    // Return full user details
    return { role, name, email, default_customer, default_opportunity };
  } catch (error) {
    console.error("Error fetching user details:", error);
    setChatMessages((prevMessages) => [
      ...prevMessages,
      { role: "error", content: "Unable to fetch user details. Please try again later." },
    ]);
    return null;
  }
};


useEffect(() => {
  const fetchSelectedAccountData = async () => {
    if (!customerOpportunities || Object.keys(customerOpportunities).length === 0) {
      console.warn("No customer opportunities available for fetching account data.");
      return;
    }

    try {
      for (const [customerName, opportunities] of Object.entries(customerOpportunities)) {
        const customerId = await fetchCustomerId(customerName);
        if (!customerId) {
          console.warn(`Could not fetch customer ID for ${customerName}`);
          continue;
        }

        // Fetch and update account data
        const accountId = await fetchAccountId(customerId, customerName);
        setAccountIdMap((prev) => ({ ...prev, [customerName]: accountId }));

        if (accountId) {
          const learnings = await fetchAccountLearnings(accountId);
          setAccountLearnings((prev) => ({ ...prev, [customerName]: learnings }));

          const tasks = await fetchDelayedTasksByRole(accountId);
          setDelayedTasks((prev) => ({ ...prev, [customerName]: tasks }));
        }
      }
    } catch (error) {
      console.error("Error fetching account data:", error);
    }
  };

  fetchSelectedAccountData();
}, [customerOpportunities]); // Ensure dependencies are accurate


// const fetchCustomerOpportunities = async (userId, apiKey, setChatMessages) => {
//   try {
//       const response = await axios8001.get(`/customer-opportunities?user_id=${userId}&api_key=${apiKey}`);
//       const customers = response.data?.customer_names_with_opportunities || {};

//       const result = Object.entries(customers).map(([customerName, opportunities]) => ({
//           customerName,
//           opportunities: Array.isArray(opportunities)
//               ? opportunities.map((opportunity, index) => ({
//                     opportunity_name: opportunity,
//                     opportunity_id: `${customerName}_Opportunity_${index}`,
//                 }))
//               : [], // Ensure it's always an array
//       }));

//       console.log("Transformed Customer Opportunities:", result);
//       return result;
//   } catch (error) {
//       console.error("Error fetching customer opportunities:", error);
//       setChatMessages((prevMessages) => [
//           ...prevMessages,
//           { role: "error", content: "Unable to fetch customer or opportunity data. Please try again later." },
//       ]);
//       return [];
//   }
// };

const fetchCustomerOpportunities = async (userId, apiKey, setChatMessages) => {
  try {
    const response = await axios8001.get(
      `/customer-opportunities?user_id=${userId}&api_key=${apiKey}`
    );
    const customers = response.data?.customer_names_with_opportunities || {};

    const result = {};

    // Loop through customers and fetch their opportunities
    for (const [customerName, opportunities] of Object.entries(customers)) {
      if (customerName && Array.isArray(opportunities)) {
        // Fetch customer ID for each customer
        const customerId = await fetchCustomerId(customerName);

        result[customerName] = opportunities.map((opportunity, index) => ({
          opportunity_name: opportunity, // Use the opportunity name as-is
          opportunity_id: `${customerName}_Opportunity_${index}`, // Generate a unique opportunity ID
          customer_id: customerId, // Dynamically fetched customer ID
        }));
      }
    }

    console.log("Transformed Customer Opportunities with Customer IDs:", result);
    return result;
  } catch (error) {
    console.error("Error fetching customer opportunities:", error);
    setChatMessages((prevMessages) => [
      ...prevMessages,
      {
        role: "error",
        content: "Unable to fetch customer or opportunity data. Please try again later.",
      },
    ]);
    return {};
  }
};




// Fetch Customer ID
const fetchCustomerId = async (customerName) => {
  try {
    const response = await axios8001.get("/get_customer_id", {
      params: {
        customer_name: customerName, // Only customer_name is required
      },
    });
    const customerId = response.data.customer_id || "unknown"; // Default to "unknown" if missing
    if (customerId === "unknown") {
      console.warn(`Customer ID not found for customer: ${customerName}`);
    }
    return customerId;
  } catch (error) {
    console.error(`Error fetching customer ID for ${customerName}:`, error);
    return "unknown"; // Fallback to "unknown" in case of an error
  }
};







// Handle Opportunity Selection
const handleOpportunitySelect = async (customerName, opportunityName) => {
  try {
    setChatMessages((prevMessages) => [
      ...prevMessages,
      {
        role: "assistant",
        content: `Fetching details for opportunity: "${opportunityName}" under customer: "${customerName}"...`,
      },
    ]);

    // Fetch customer ID
    const customerId = await fetchCustomerId(customerName, userId, apiKey);
    if (customerId === "unknown") {
      throw new Error(`Failed to fetch customer ID for ${customerName}.`);
    }

    // Fetch opportunity ID
    const opportunityId = await fetchOpportunityId(customerId, opportunityName, userId, apiKey);
    if (opportunityId === "unknown") {
      throw new Error(`Failed to fetch opportunity ID for ${opportunityName}.`);
    }

    // Update state with selected values
    setSelectedOpportunityId(opportunityId);
    setSelectedCustomerName(customerName);
    setSelectedOpportunityName(opportunityName);

    setChatMessages((prevMessages) => [
      ...prevMessages,
      {
        role: "assistant",
        content: `You have selected the opportunity: "${opportunityName}" under customer: "${customerName}". How can I assist you further?`,
      },
    ]);
  } catch (error) {
    console.error("Error handling opportunity selection:", error.message);
    setChatMessages((prevMessages) => [
      ...prevMessages,
      {
        role: "error",
        content: "Failed to fetch opportunity details. Please try again later.",
      },
    ]);
  }
};


// const renderAskCoachTile = () => {
//   const handleSendMessageWithContext = async (buttonKey) => {
//     const context = buttonKey ? contexts[buttonKey] : inputValue?.trim();

//     if (!context) {
//       setChatMessages((prevMessages) => [
//         ...prevMessages,
//         { role: "error", content: "Query cannot be empty. Please type a question or select an option." },
//       ]);
//       return;
//     }

//     if (!userId || !apiKey) {
//       setChatMessages((prevMessages) => [
//         ...prevMessages,
//         { role: "error", content: "User ID or API Key is missing. Please log in again." },
//       ]);
//       return;
//     }

//     setLoadingChat(true);

//     try {
//       // Construct the payload dynamically
//       const payload = {
//         user_id: userId,
//         api_key: apiKey,
//         user_query: context,
//       };

//       // Add query type or additional fields as needed
//       if (buttonKey) {
//         payload.query_type = "button"; // Indicate button-based query
//       }

//       // Include customer_name and opportunity_name if they exist
//       if (selectedCustomerName) {
//         payload.customer_name = selectedCustomerName;
//       }
//       if (selectedOpportunityName) {
//         payload.opportunity_name = selectedOpportunityName;
//       }

//       // Log the payload for debugging
//       console.log("Sending payload to /direct-chat:", payload);

//       // Make the API call
//       const { data } = await axios8000.post("/direct-chat", payload, {
//         headers: { "Content-Type": "application/json" },
//       });

//       console.log("Received response:", data);

//       // Process the response
//       const assistantResponse = data?.response || "No response received.";

//       // Update chat messages
//       setChatMessages((prevMessages) => [
//         ...prevMessages,
//         { role: "user", content: context }, // User's query
//         { role: "assistant", content: assistantResponse }, // Assistant's response
//       ]);
//     } catch (error) {
//       console.error("Error during /direct-chat:", error);
//       setChatMessages((prevMessages) => [
//         ...prevMessages,
//         { role: "error", content: "Failed to fetch response. Please try again later." },
//       ]);
//     } finally {
//       setLoadingChat(false);
//       if (!buttonKey) setInputValue(""); // Clear input field only for typed queries
//     }
//   };

//   return (
//     <div className="ask-coach-tile">
//       {/* Header Section */}
//       <div className="ask-coach-header">
//         <h3>Ask Coach</h3>
//         <button
//           onClick={() => {
//             setShowAskCoachTile(false);
//           }}
//           className="close-tile"
//         >
//           ✕
//         </button>
//       </div>

//       {/* Chat Messages Section */}
//       <div className="chat-messages">
//         {chatMessages.map((message, index) => (
//           <div key={index} className={`chat-message ${message.role}`}>
//             {message.content}
//           </div>
//         ))}
//       </div>

//       {/* Context Buttons */}
//       <div className="context-buttons">
//         {Object.keys(contexts).map((buttonKey) => (
//           <button
//             key={buttonKey}
//             onClick={() => handleSendMessageWithContext(buttonKey)}
//             className="context-button"
//           >
//             {buttonKey}
//           </button>
//         ))}
//       </div>

//       {/* Chat Input */}
//       <div className="chat-container">
//         <div className="chat-input">
//           <input
//             type="text"
//             placeholder="Type your question here..."
//             value={inputValue}
//             onChange={(e) => setInputValue(e.target.value)}
//             disabled={loadingChat}
//           />
//           <button
//             onClick={() => handleSendMessageWithContext()}
//             disabled={!inputValue.trim() || loadingChat}
//             className="send-button"
//           >
//             {loadingChat ? "Sending..." : "Send"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };



const renderBulletedResponse = (response) => {
  if (!response) return null;

  // Split the response into bullet points based on numbering or bullet characters
  const bulletPoints = response.split(/\d\.\s|\n/).filter((point) => point.trim() !== "");

  return (
    <div className="formatted-response">
      <h4>Response</h4>
      <ul className="formatted-response-list">
        {bulletPoints.map((point, index) => (
          <li key={index} className="formatted-response-item">
            {point.trim()}
          </li>
        ))}
      </ul>
    </div>
  );
};

const renderAskCoachTile = () => {
  
  const renderFormattedResponse = (content) => {
    // Step 1: Extract sections with regex
    const sections = content.split(/\*\*(Analysis|Recommendations|Next Steps)\*\*/g).reduce((acc, curr, idx, arr) => {
      if (idx % 2 === 1) {
        acc[curr.trim()] = arr[idx + 1]?.trim() || "";
      }
      return acc;
    }, {});
  
    // Step 2: Format numbered lists into separate paragraphs
    const formatContent = (text) => {
      return text.split(/\n|(?=\d\.\s)/g).map((item, idx) => (
        <p key={idx} className="text-gray-800 mb-2">
          {item.trim()}
        </p>
      ));
    };
  
    // Step 3: Render sections in separate styled boxes
    return (
      <div className="response-container">
        {sections.Analysis && (
          <div className="analysis-box p-4 border rounded shadow-sm mb-4 bg-gray-100">
            <h4 className="font-bold text-blue-500 mb-2">Analysis</h4>
            <p>{sections.Analysis}</p>
          </div>
        )}
  
        {sections.Recommendations && (
          <div className="recommendations-box p-4 border rounded shadow-sm mb-4 bg-gray-50">
            <h4 className="font-bold text-green-500 mb-2">Recommendations</h4>
            {formatContent(sections.Recommendations)}
          </div>
        )}
  
        {sections["Next Steps"] && (
          <div className="next-steps-box p-4 border rounded shadow-sm bg-gray-50">
            <h4 className="font-bold text-purple-500 mb-2">Next Steps</h4>
            {formatContent(sections["Next Steps"])}
          </div>
        )}
      </div>
    );
  };
  
  
  const handleSendMessageWithContext = async (buttonKey) => {
    const context = buttonKey ? contexts[buttonKey] : inputValue?.trim();

    if (!context) {
      setChatMessages((prevMessages) => [
        ...prevMessages,
        { role: "error", content: "Query cannot be empty. Please type a question or select an option." },
      ]);
      return;
    }

    if (!userId || !apiKey) {
      setChatMessages((prevMessages) => [
        ...prevMessages,
        { role: "error", content: "User ID or API Key is missing. Please log in again." },
      ]);
      return;
    }

    setLoadingChat(true);

    try {
      // Construct the payload dynamically
      const payload = {
        user_id: userId,
        api_key: apiKey,
        user_query: context,
      };

      // Include customer_name and opportunity_name if they exist
      if (selectedCustomerName) {
        payload.customer_name = selectedCustomerName;
      }
      if (selectedOpportunityName) {
        payload.opportunity_name = selectedOpportunityName;
      }

      // Log the payload for debugging
      console.log("Sending payload to /direct-chat:", payload);

      // Make the API call
      const { data } = await axios8000.post("/direct-chat", payload, {
        headers: { "Content-Type": "application/json" },
      });

      console.log("Received response:", data);

      // Process the response
      const assistantResponse = data?.response || "No response received.";

      // Update chat messages
      setChatMessages((prevMessages) => [
        ...prevMessages,
        { role: "user", content: context }, // User's query
        { role: "assistant", content: assistantResponse }, // Assistant's response
      ]);
    } catch (error) {
      console.error("Error during /direct-chat:", error);
      setChatMessages((prevMessages) => [
        ...prevMessages,
        { role: "error", content: "Failed to fetch response. Please try again later." },
      ]);
    } finally {
      setLoadingChat(false);
      if (!buttonKey) setInputValue(""); // Clear input field only for typed queries
    }
  };

  return (
    <div className="ask-coach-tile">
      {/* Header Section */}
      <div className="ask-coach-header">
        <h3>Ask Coach</h3>
        <button
          onClick={() => setShowAskCoachTile(false)}
          className="close-tile"
          aria-label="Close Ask Coach Tile"
        >
          ✕
        </button>
      </div>
  
      {/* Dropdown Selection Section */}
      <div className="selection-section">
        {/* Customer Dropdown */}
        <div className="dropdown-container">
          <label htmlFor="customer-dropdown">Select Customer:</label>
          <select
            id="customer-dropdown"
            value={selectedCustomerName || ""}
            onChange={(e) => setSelectedCustomerName(e.target.value)}
            aria-label="Select a customer"
          >
            <option value="" disabled>
              {Object.keys(customerOpportunities).length > 0
                ? "Select a Customer"
                : "No Customers Available"}
            </option>
            {Object.keys(customerOpportunities).map((customer) => (
              <option key={customer} value={customer}>
                {customer}
              </option>
            ))}
          </select>
        </div>
  
        {/* Opportunity Dropdown */}
        <div className="dropdown-container">
          <label htmlFor="opportunity-dropdown">Select Opportunity:</label>
          <select
            id="opportunity-dropdown"
            value={selectedOpportunityName || ""}
            onChange={(e) => setSelectedOpportunityName(e.target.value)}
            disabled={
              !selectedCustomerName || !customerOpportunities[selectedCustomerName]
            }
            aria-label="Select an opportunity"
          >
            <option value="" disabled>
              {selectedCustomerName
                ? "Select an Opportunity"
                : "Select a Customer First"}
            </option>
            {(customerOpportunities[selectedCustomerName] || []).map(
              (opportunity) => (
                <option key={opportunity.opportunity_id} value={opportunity.opportunity_id}>
                  {opportunity.opportunity_name}
                </option>
              )
            )}
          </select>
        </div>
      </div>
  
      {/* Chat Messages Section */}
      {/* Chat Messages Section */}
<div className="chat-messages">
  {chatMessages.length > 0 ? (
    chatMessages.map((message, index) => (
      <div
        key={index}
        className={`chat-message ${message.role}`}
        aria-live="polite"
      >
        {/* Render User's Query */}
        {message.role === "user" ? (
          <p className="text-gray-900 font-medium">{message.content}</p>
        ) : (
          // Render Assistant's Formatted Response
          renderFormattedResponse(message.content)
        )}
      </div>
    ))
  ) : (
    <p>No messages yet. Start the conversation below.</p>
  )}
</div>

  

  
      {/* Context Buttons */}
      <div className="context-buttons">
        {Object.keys(contexts).map((buttonKey) => (
          <button
            key={buttonKey}
            onClick={() => handleSendMessageWithContext(buttonKey)}
            className="context-button"
            aria-label={`Use context: ${buttonKey}`}
          >
            {buttonKey}
          </button>
        ))}
      </div>
  
      {/* Chat Input Section */}
      <div className="chat-input">
        <input
          type="text"
          placeholder="Type your question here..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          aria-label="Type your question"
        />
        <button
          onClick={() => handleSendMessageWithContext()}
          disabled={loadingChat}
          aria-label="Send your question"
        >
          {loadingChat ? "Sending..." : "Send"}
        </button>
      </div>
    </div>
  );
  
  
  
}  

useEffect(() => {
  chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
}, [chatMessages]);

  // Function to handle sending payload to your chat API
  const sendToChatAPI = async (payload) => {
    try {
      const response = await axios8000.post("/ask", payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("Message sent successfully:", response.data);
      return response.data;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };

  useEffect(() => {
    const initializeUser = async () => {
      const userDetails = await fetchUserDetails(userId, apiKey, setChatMessages);
      if (userDetails) {
        // Perform actions with user details
      }
    };
    initializeUser();
  }, [userId, apiKey]);

  useEffect(() => {
    const fetchOpportunities = async () => {
      const opportunities = await fetchCustomerOpportunities(userId, apiKey, setChatMessages);
      setCustomerOpportunities(opportunities); // Assuming setCustomerOpportunities is a state setter
    };
    fetchOpportunities();
  }, [userId, apiKey]);

  const handleDropdownChange = (customerName, opportunityName) => {
    handleOpportunitySelect(customerName, opportunityName);
  };
  const handleRoleUpdate = (newRole) => {
    updateUserRole(userId, newRole);
  };
    
    
  useEffect(() => {
    const chatContainer = document.querySelector(".chat-container");
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  }, [chatMessages]);

  const searchParams = new URLSearchParams(location.search);
  const urlCustomerName = searchParams.get("customer_name");

    return (
      <div>
        {/* Navbar */}
        <DashboardNavbar
          onButtonClick={(buttonName) => {
            const modalMapping = {
              "Save Lead or Qualified Opportunity": "createOpportunity",
              "Create Opportunity": "createOpportunity",
              "Create Account Plan Workflow": "createAccountPlan",
              "Create Account Plan": "createAccountPlan",
            };
    
            const mappedModalType = modalMapping[buttonName];
            if (mappedModalType) {
              setModalType(mappedModalType);
            } else if (buttonName === "ask-coach") {
              setShowAskCoachTile(true);
            } else {
              alert("This button is not yet implemented.");
            }
          }}
          onLogout={() => {
            sessionStorage.clear();
            window.location.href = "/";
          }}
        />
    
        {/* Ask Coach Tile Section */}
        {showAskCoachTile && renderAskCoachTile()}
    
       {/* Modal Section */}
{modalType && (
  <div
    className="modal-overlay"
    role="dialog"
    aria-labelledby="modalTitle"
    aria-describedby="modalDescription"
    aria-modal="true"
  >
    <div className="modal-content">
      {/* Modal Header */}
      <div className="modal-header">
        <h3 id="modalTitle">{getModalTitle()}</h3>
        <button
          onClick={() => {
            setModalType(null);
            resetForm();
          }}
          className="modal-close-btn"
        >
          ×
        </button>
      </div>

      {/* Modal Body */}
      <div className="modal-body">
        {modalType === "createAccountPlan" && (
          <form onSubmit={handleAccountPlanSubmit}>
            <div className="form-group">
              <label htmlFor="customerName">Customer Name</label>
              <input
                type="text"
                id="customerName"
                value={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="contact">Contact</label>
              <input
                type="text"
                id="contact"
                value={contact}
                onChange={(e) => setContact(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="industry">Industry</label>
              <input
                type="text"
                id="industry"
                value={industry}
                onChange={(e) => setIndustry(e.target.value)}
              />
            </div>

            {[
              "ACCOUNT HEALTH ASSESSMENT",
              "VALUE PYRAMID",
              "MACRO ECONOMIC & INDUSTRY TRENDS",
              "BUSINESS ISSUES & OBJECTIVES",
              "RELATIONSHIP MAPPING",
              "WHITESPACE MAPPING",
              "VALUE MAPPING",
              "ACTIONABLE QTR BY QTR PLAN",
              "All Execution",
              "Next Steps",
            ].map((section) => (
              <div className="form-group" key={section}>
                <label>{section}</label>
                <textarea
                  rows="3"
                  value={sections[section] || ""}
                  onChange={(e) =>
                    setSections({ ...sections, [section]: e.target.value })
                  }
                  placeholder={`Enter details for ${section}`}
                />
              </div>
            ))}
          </form>
        )}

        {/* Try Value Pyramid Modal Form */}
        {modalType === "tryValuePyramid" && (
          <form>
            <div className="form-group">
              <label htmlFor="customerName">Customer Name</label>
              <input
                type="text"
                id="customerName"
                value={formData.customerName}
                onChange={(e) => handleInputChange("customerName", e.target.value)}
                required
                placeholder="Enter Customer Name"
              />
            </div>
            <div className="form-group">
              <label htmlFor="industry">Industry</label>
              <input
                type="text"
                id="industry"
                value={formData.industry}
                onChange={(e) => handleInputChange("industry", e.target.value)}
                placeholder="Enter Industry"
              />
            </div>
            <div className="form-group">
              <label htmlFor="persona">Persona</label>
              <input
                type="text"
                id="persona"
                value={formData.persona}
                onChange={(e) => handleInputChange("persona", e.target.value)}
                placeholder="Enter Persona"
              />
            </div>
            <div className="form-group">
              <label htmlFor="solutionType">Solution Type</label>
              <input
                type="text"
                id="solutionType"
                value={formData.solutionType}
                onChange={(e) => handleInputChange("solutionType", e.target.value)}
                placeholder="Enter Solution Type"
              />
            </div>
            <div className="form-group">
              <label htmlFor="solution">Solution</label>
              <input
                type="text"
                id="solution"
                value={formData.solution}
                onChange={(e) => handleInputChange("solution", e.target.value)}
                placeholder="Enter Solution"
              />
            </div>
            <div className="form-group">
              <label htmlFor="vendor">Vendor</label>
              <input
                type="text"
                id="vendor"
                value={formData.vendor}
                onChange={(e) => handleInputChange("vendor", e.target.value)}
                placeholder="Enter Vendor"
              />
            </div>
          </form>
        )}
      </div>

      {/* Modal Footer */}
      <div className="modal-footer">
        {modalType === "createAccountPlan" && (
          <>
            <button
              onClick={handleAnalyzeAccountPlan}
              disabled={loading}
              className="btn-primary"
            >
              Analyze Account Plan
            </button>
            <button
              onClick={handleAccountPlanSubmit}
              disabled={loading}
              className="btn-success"
            >
              {loading ? "Saving..." : "Submit"}
            </button>
          </>
        )}
        {modalType === "tryValuePyramid" && (
          <>
            <button
              onClick={handleGenerateValuePyramid}
              disabled={loading}
              className="btn-primary"
            >
              Generate Value Pyramid
            </button>
            <button
              onClick={() => {
                setModalType(null);
                resetForm();
              }}
              className="btn-cancel"
            >
              Cancel
            </button>
          </>
        )}
      </div>
    </div>
  </div>
)}


    
<div className={`dashboard-container ${isVisible ? 'expanded' : 'collapsed'}`}>
  {/* Dashboard Header */}
  <header className="dashboard-header">
    <a
      href="#"
      className="toggle-link"
      onClick={(e) => {
        e.preventDefault();
        toggleTilesVisibility(); // Toggle tiles visibility
      }}
    >
      Start from Here
    </a>
  </header>

  <div className={`tiles-container ${isVisible ? 'visible' : ''}`}>
  {tiles.map((tile) => (
    <div
      key={tile.id}
      className="tile"
      onClick={(e) => {
        e.stopPropagation();
        handleOpenModal(tile.id);
      }}
    >
      <div className="tile-icon">{tile.icon}</div>
      <div className="tile-content">
        <h4>{tile.name}</h4>
        <p>{tile.description}</p>
      </div>
    </div>
  ))}
</div>

{/* Modal Section */}
{renderModal()}



    {/* Customer Section */}
   {/* <div className="customer-section"> //}
      {/* Render customer-related content here */}
     {/* <h3>Customer Section</h3> */}
      {/*<p>Manage your customer accounts and related strategies.</p>*/}
    {/*</div>*/}

    
  {/* Modal Section */}
</div>
{/* Sales Dashboard */}
<section className="sales-dashboard-section">
    {totalValue !== undefined && funnelData && forecastData ? (
      <SalesDashboard
      totalValue={processedData.totalValue}
      dealsData={processedData.dealsData}
      funnelData={processedData.funnelData}
      forecastData={processedData.forecastData}
    />
    ) : (
      <p>Loading sales data...</p>
    )}
  </section>
{/* Customers and Opportunities Section */}
<div className="customers-opportunities-section">
  {customerOpportunities && Object.keys(customerOpportunities).length > 0 ? (
    Object.entries(customerOpportunities).map(([customerName, opportunities]) => {
      if (!customerName || !Array.isArray(opportunities)) {
        console.error("Invalid customer data:", { customerName, opportunities });
        return (
          <div key={customerName || "unknown"} className="customer-section">
            <h4 className="text-red-500">Invalid Customer Data</h4>
            <p className="text-gray-400">Unable to load opportunities for this customer.</p>
          </div>
        );
      }

      return (
        <div key={customerName} className="customer-section">
          {/* Customer Header */}
          <h4 className="text-blue-500 font-bold text-lg">
            <a
              href={`/customer/${encodeURIComponent(customerName)}`}
              className="text-blue-500 hover:underline"
            >
              {customerName}
            </a>
          </h4>

          {/* Account Details */}
          <div className="account-details">
            <p className="text-gray-1000 font-medium">
              <strong>Account ID:</strong> {accountIdMap?.[customerName] || "Fetching..."}
            </p>

            {/* Account Learnings */}
            {/* <div>
              <p className="text-gray-1000 font-bold">Learnings:</p>
              {accountLearnings?.[customerName] ? (
                <ul className="text-gray-1000">
                  {Object.entries(accountLearnings[customerName]).map(([role, learnings]) => (
                    <li key={role}>
                      <h5 className="font-medium">{role}:</h5>
                      <ul>
                        {Array.isArray(learnings) ? (
                          learnings.map((point, index) => <li key={index}>{point}</li>)
                        ) : (
                          <li>{learnings}</li>
                        )}
                      </ul>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-gray-800">No learnings available.</p>
              )}
            </div> */}

            {/* Delayed Tasks */}
            <div>
              <p className="text-gray-1000 font-bold">Delayed Tasks by Role:</p>
              {delayedTasks?.[customerName] ? (
                <ul className="text-gray-1000">
                  {Object.entries(delayedTasks[customerName]).map(([role, count]) => (
                    <li key={role}>
                      {role}: {count} tasks delayed
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-gray-800">No delayed tasks available.</p>
              )}
            </div>
          </div>

          {/* Opportunities List */}
          {/* Opportunities List */}
<ul className="opportunity-list">
  {opportunities.length > 0 ? (
    opportunities.map((opportunity) => {
      const { opportunity_id: opportunityId, customer_id: customerId, opportunity_name: opportunityName } = opportunity;
      const metrics = opportunityMetrics?.[opportunityId];
      const salesStageHealth = opportunityData?.[opportunityId]?.salesStageHealth;
      const closingProbability = (opportunityData?.[opportunityId]?.probability || 0) * 100;
      const nextSteps = opportunityData?.[opportunityId]?.nextSteps || []; // Fetch next steps

      if (!opportunityId || !customerId || !opportunityName) {
        return (
          <li key={`unknown-${Math.random()}`} className="text-gray-400">
            Incomplete opportunity data
          </li>
        );
      }

      return (
        <li
          key={opportunityId}
          className="p-4 border rounded shadow-sm mb-2 opportunity-item"
        >
          {/* Opportunity Name */}
          <div className="opportunity-header">
            <a
              href={`/opportunity/${encodeURIComponent(opportunity.opportunity_id)}?customer_id=${encodeURIComponent(
                opportunity.customer_id
              )}&customer_name=${encodeURIComponent(customerName)}&opportunity_name=${encodeURIComponent(
                opportunity.opportunity_name
              )}`}
              className="text-blue-500 hover:underline font-medium"
            >
              {opportunityName}
            </a>
          </div>

          {/* Metrics Visualization */}
          <div className="metrics-section">
            <h5 className="font-bold">Metrics:</h5>
            {renderMetrics(metrics)}
          </div>

          {/* Closing Probability */}
          <div className="closing-probability-tile">
            <ClosingProbabilityTile closingProbability={closingProbability} />
          </div>

          {/* Sales Stage Health */}
          <div className="sales-stage-health-section">
            {renderSalesStageHealth(salesStageHealth)}
          </div>

          {/* Next Steps */}
          {/* Always Render Next Steps */}
<div className="next-steps-section mt-4">
  <h5 className="font-bold">Next Steps:</h5>
  {Object.keys(nextSteps).length > 0 ? ( // Check if there are any keys in the object
    <ul className="next-steps-list">
      {Object.entries(nextSteps).map(([role, steps]) => (
        <li key={role} className="next-steps-role">
          <strong>{role}:</strong>
          <ul>
            {steps.map((step, index) => (
              <li key={index} className="text-gray-800">
                {step}
              </li>
            ))}
          </ul>
        </li>
      ))}
    </ul>
  ) : (
    <p className="text-gray-400">No next steps available.</p>
  )}
</div>
        </li>
      );
    })
  ) : (
    <li className="text-gray-400">No opportunities available.</li>
  )}
</ul>



        </div>
      );
    })
  ) : (
    <p className="text-gray-400">No customers or opportunities available. Start by creating one!</p>
  )}
</div>





 

    

    </div>
 
  );
};

export default Dashboard;